// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  /*!
   * Quill Editor v1.3.6
   * https://quilljs.com/
   * Copyright (c) 2014, Jason Chen
   * Copyright (c) 2013, salesforce.com
   */
  /*!
   * Quill Editor v1.3.6
   * https://quilljs.com/
   * Copyright (c) 2014, Jason Chen
   * Copyright (c) 2013, salesforce.com
   */
}
:host [contenteditable] {
  -webkit-user-select: text;
  user-select: text;
}
:host .photo-placeholder {
  --padding-start: 0;
  width: 100%;
  cursor: pointer;
  --inner-padding-end: 10px;
  --inner-padding-start: 10px;
  --inner-padding-top: 15px;
  position: relative;
}
:host .photo-placeholder .photo-container {
  position: relative;
  width: 100%;
}
:host .photo-placeholder ion-icon {
  position: absolute;
  top: 7px;
  right: 7px;
  border-radius: 50%;
  padding: 11px;
  height: 30px;
  width: 30px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  background-color: #f4f5f8;
  color: var(--cms-button-bg-color);
  box-shadow: 0 0 8px 3px #151515;
  z-index: 10;
}
:host .photo-placeholder img {
  width: 100%;
  max-height: 200px;
  text-align: center;
  object-fit: cover;
}
:host ion-list > ion-label {
  font-size: inherit;
}
:host .ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}
:host .ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
:host .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
  pointer-events: none;
}
:host .ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
:host .ql-clipboard p {
  margin: 0;
  padding: 0;
}
:host .ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
:host .ql-editor > * {
  cursor: text;
}
:host .ql-editor p,
:host .ql-editor ol,
:host .ql-editor ul,
:host .ql-editor pre,
:host .ql-editor blockquote,
:host .ql-editor h1,
:host .ql-editor h2,
:host .ql-editor h3,
:host .ql-editor h4,
:host .ql-editor h5,
:host .ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol,
:host .ql-editor ul {
  padding-left: 1.5em;
}
:host .ql-editor ol > li,
:host .ql-editor ul > li {
  list-style-type: none;
}
:host .ql-editor ul > li::before {
  content: "•";
}
:host .ql-editor ul[data-checked=true],
:host .ql-editor ul[data-checked=false] {
  pointer-events: none;
}
:host .ql-editor ul[data-checked=true] > li *,
:host .ql-editor ul[data-checked=false] > li * {
  pointer-events: all;
}
:host .ql-editor ul[data-checked=true] > li::before,
:host .ql-editor ul[data-checked=false] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
:host .ql-editor ul[data-checked=true] > li::before {
  content: "☑";
}
:host .ql-editor ul[data-checked=false] > li::before {
  content: "☐";
}
:host .ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
:host .ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
:host .ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
:host .ql-editor ol li:not(.ql-direction-rtl),
:host .ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
:host .ql-editor ol li.ql-direction-rtl,
:host .ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
:host .ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
:host .ql-editor ol li:before {
  content: counter(list-0, decimal) ". ";
}
:host .ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
:host .ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}
:host .ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
:host .ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}
:host .ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}
:host .ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}
:host .ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}
:host .ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}
:host .ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}
:host .ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}
:host .ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}
:host .ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}
:host .ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}
:host .ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}
:host .ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
:host .ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}
:host .ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}
:host .ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}
:host .ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}
:host .ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}
:host .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
:host .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
:host .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
:host .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
:host .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
:host .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
:host .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
:host .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
:host .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
:host .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
:host .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
:host .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
:host .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
:host .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
:host .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
:host .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
:host .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
:host .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
:host .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
:host .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
:host .ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
:host .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
:host .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
:host .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
:host .ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
:host .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
:host .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
:host .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
:host .ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
:host .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
:host .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
:host .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
:host .ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
:host .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
:host .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
:host .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
:host .ql-editor .ql-video {
  display: block;
  max-width: 100%;
}
:host .ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}
:host .ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
:host .ql-editor .ql-bg-black {
  background-color: #000;
}
:host .ql-editor .ql-bg-red {
  background-color: #e60000;
}
:host .ql-editor .ql-bg-orange {
  background-color: #f90;
}
:host .ql-editor .ql-bg-yellow {
  background-color: #ff0;
}
:host .ql-editor .ql-bg-green {
  background-color: #008a00;
}
:host .ql-editor .ql-bg-blue {
  background-color: #06c;
}
:host .ql-editor .ql-bg-purple {
  background-color: #93f;
}
:host .ql-editor .ql-color-white {
  color: #fff;
}
:host .ql-editor .ql-color-red {
  color: #e60000;
}
:host .ql-editor .ql-color-orange {
  color: #f90;
}
:host .ql-editor .ql-color-yellow {
  color: #ff0;
}
:host .ql-editor .ql-color-green {
  color: #008a00;
}
:host .ql-editor .ql-color-blue {
  color: #06c;
}
:host .ql-editor .ql-color-purple {
  color: #93f;
}
:host .ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
:host .ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
:host .ql-editor .ql-size-small {
  font-size: 0.75em;
}
:host .ql-editor .ql-size-large {
  font-size: 1.5em;
}
:host .ql-editor .ql-size-huge {
  font-size: 2.5em;
}
:host .ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
:host .ql-editor .ql-align-center {
  text-align: center;
}
:host .ql-editor .ql-align-justify {
  text-align: justify;
}
:host .ql-editor .ql-align-right {
  text-align: right;
}
:host .ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}
:host .ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}
:host .ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
:host .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
  pointer-events: none;
}
:host .ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
:host .ql-clipboard p {
  margin: 0;
  padding: 0;
}
:host .ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
:host .ql-editor > * {
  cursor: text;
}
:host .ql-editor p,
:host .ql-editor ol,
:host .ql-editor ul,
:host .ql-editor pre,
:host .ql-editor blockquote,
:host .ql-editor h1,
:host .ql-editor h2,
:host .ql-editor h3,
:host .ql-editor h4,
:host .ql-editor h5,
:host .ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol,
:host .ql-editor ul {
  padding-left: 1.5em;
}
:host .ql-editor ol > li,
:host .ql-editor ul > li {
  list-style-type: none;
}
:host .ql-editor ul > li::before {
  content: "•";
}
:host .ql-editor ul[data-checked=true],
:host .ql-editor ul[data-checked=false] {
  pointer-events: none;
}
:host .ql-editor ul[data-checked=true] > li *,
:host .ql-editor ul[data-checked=false] > li * {
  pointer-events: all;
}
:host .ql-editor ul[data-checked=true] > li::before,
:host .ql-editor ul[data-checked=false] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
:host .ql-editor ul[data-checked=true] > li::before {
  content: "☑";
}
:host .ql-editor ul[data-checked=false] > li::before {
  content: "☐";
}
:host .ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
:host .ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
:host .ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
:host .ql-editor ol li:not(.ql-direction-rtl),
:host .ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
:host .ql-editor ol li.ql-direction-rtl,
:host .ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
:host .ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
:host .ql-editor ol li:before {
  content: counter(list-0, decimal) ". ";
}
:host .ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
:host .ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}
:host .ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
:host .ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}
:host .ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}
:host .ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}
:host .ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}
:host .ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}
:host .ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}
:host .ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}
:host .ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}
:host .ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}
:host .ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}
:host .ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}
:host .ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
:host .ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}
:host .ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}
:host .ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}
:host .ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}
:host .ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}
:host .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
:host .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
:host .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
:host .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
:host .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
:host .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
:host .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
:host .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
:host .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
:host .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
:host .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
:host .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
:host .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
:host .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
:host .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
:host .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
:host .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
:host .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
:host .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
:host .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
:host .ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
:host .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
:host .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
:host .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
:host .ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
:host .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
:host .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
:host .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
:host .ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
:host .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
:host .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
:host .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
:host .ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
:host .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
:host .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
:host .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
:host .ql-editor .ql-video {
  display: block;
  max-width: 100%;
}
:host .ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}
:host .ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
:host .ql-editor .ql-bg-black {
  background-color: #000;
}
:host .ql-editor .ql-bg-red {
  background-color: #e60000;
}
:host .ql-editor .ql-bg-orange {
  background-color: #f90;
}
:host .ql-editor .ql-bg-yellow {
  background-color: #ff0;
}
:host .ql-editor .ql-bg-green {
  background-color: #008a00;
}
:host .ql-editor .ql-bg-blue {
  background-color: #06c;
}
:host .ql-editor .ql-bg-purple {
  background-color: #93f;
}
:host .ql-editor .ql-color-white {
  color: #fff;
}
:host .ql-editor .ql-color-red {
  color: #e60000;
}
:host .ql-editor .ql-color-orange {
  color: #f90;
}
:host .ql-editor .ql-color-yellow {
  color: #ff0;
}
:host .ql-editor .ql-color-green {
  color: #008a00;
}
:host .ql-editor .ql-color-blue {
  color: #06c;
}
:host .ql-editor .ql-color-purple {
  color: #93f;
}
:host .ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
:host .ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
:host .ql-editor .ql-size-small {
  font-size: 0.75em;
}
:host .ql-editor .ql-size-large {
  font-size: 1.5em;
}
:host .ql-editor .ql-size-huge {
  font-size: 2.5em;
}
:host .ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
:host .ql-editor .ql-align-center {
  text-align: center;
}
:host .ql-editor .ql-align-justify {
  text-align: justify;
}
:host .ql-editor .ql-align-right {
  text-align: right;
}
:host .ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}
:host .ql-bubble.ql-toolbar:after,
:host .ql-bubble .ql-toolbar:after {
  clear: both;
  content: "";
  display: table;
}
:host .ql-bubble.ql-toolbar button,
:host .ql-bubble .ql-toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  padding: 3px 5px;
  width: 28px;
}
:host .ql-bubble.ql-toolbar button svg,
:host .ql-bubble .ql-toolbar button svg {
  float: left;
  height: 100%;
}
:host .ql-bubble.ql-toolbar button:active:hover,
:host .ql-bubble .ql-toolbar button:active:hover {
  outline: none;
}
:host .ql-bubble.ql-toolbar input.ql-image[type=file],
:host .ql-bubble .ql-toolbar input.ql-image[type=file] {
  display: none;
}
:host .ql-bubble.ql-toolbar button:hover,
:host .ql-bubble .ql-toolbar button:hover,
:host .ql-bubble.ql-toolbar button:focus,
:host .ql-bubble .ql-toolbar button:focus,
:host .ql-bubble.ql-toolbar button.ql-active,
:host .ql-bubble .ql-toolbar button.ql-active,
:host .ql-bubble.ql-toolbar .ql-picker-label:hover,
:host .ql-bubble .ql-toolbar .ql-picker-label:hover,
:host .ql-bubble.ql-toolbar .ql-picker-label.ql-active,
:host .ql-bubble .ql-toolbar .ql-picker-label.ql-active,
:host .ql-bubble.ql-toolbar .ql-picker-item:hover,
:host .ql-bubble .ql-toolbar .ql-picker-item:hover,
:host .ql-bubble.ql-toolbar .ql-picker-item.ql-selected,
:host .ql-bubble .ql-toolbar .ql-picker-item.ql-selected {
  color: #fff;
}
:host .ql-bubble.ql-toolbar button:hover .ql-fill,
:host .ql-bubble .ql-toolbar button:hover .ql-fill,
:host .ql-bubble.ql-toolbar button:focus .ql-fill,
:host .ql-bubble .ql-toolbar button:focus .ql-fill,
:host .ql-bubble.ql-toolbar button.ql-active .ql-fill,
:host .ql-bubble .ql-toolbar button.ql-active .ql-fill,
:host .ql-bubble.ql-toolbar .ql-picker-label:hover .ql-fill,
:host .ql-bubble .ql-toolbar .ql-picker-label:hover .ql-fill,
:host .ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-fill,
:host .ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-fill,
:host .ql-bubble.ql-toolbar .ql-picker-item:hover .ql-fill,
:host .ql-bubble .ql-toolbar .ql-picker-item:hover .ql-fill,
:host .ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
:host .ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
:host .ql-bubble.ql-toolbar button:hover .ql-stroke.ql-fill,
:host .ql-bubble .ql-toolbar button:hover .ql-stroke.ql-fill,
:host .ql-bubble.ql-toolbar button:focus .ql-stroke.ql-fill,
:host .ql-bubble .ql-toolbar button:focus .ql-stroke.ql-fill,
:host .ql-bubble.ql-toolbar button.ql-active .ql-stroke.ql-fill,
:host .ql-bubble .ql-toolbar button.ql-active .ql-stroke.ql-fill,
:host .ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
:host .ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
:host .ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
:host .ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
:host .ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
:host .ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
:host .ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
:host .ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: #fff;
}
:host .ql-bubble.ql-toolbar button:hover .ql-stroke,
:host .ql-bubble .ql-toolbar button:hover .ql-stroke,
:host .ql-bubble.ql-toolbar button:focus .ql-stroke,
:host .ql-bubble .ql-toolbar button:focus .ql-stroke,
:host .ql-bubble.ql-toolbar button.ql-active .ql-stroke,
:host .ql-bubble .ql-toolbar button.ql-active .ql-stroke,
:host .ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke,
:host .ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke,
:host .ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
:host .ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
:host .ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke,
:host .ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke,
:host .ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
:host .ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
:host .ql-bubble.ql-toolbar button:hover .ql-stroke-miter,
:host .ql-bubble .ql-toolbar button:hover .ql-stroke-miter,
:host .ql-bubble.ql-toolbar button:focus .ql-stroke-miter,
:host .ql-bubble .ql-toolbar button:focus .ql-stroke-miter,
:host .ql-bubble.ql-toolbar button.ql-active .ql-stroke-miter,
:host .ql-bubble .ql-toolbar button.ql-active .ql-stroke-miter,
:host .ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
:host .ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
:host .ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
:host .ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
:host .ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
:host .ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
:host .ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
:host .ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
  stroke: #fff;
}
@media (pointer: coarse) {
  :host .ql-bubble.ql-toolbar button:hover:not(.ql-active),
  :host .ql-bubble .ql-toolbar button:hover:not(.ql-active) {
    color: #ccc;
  }
  :host .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-fill,
  :host .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-fill,
  :host .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
  :host .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
    fill: #ccc;
  }
  :host .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  :host .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  :host .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
  :host .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
    stroke: #ccc;
  }
}
:host .ql-bubble {
  box-sizing: border-box;
}
:host .ql-bubble * {
  box-sizing: border-box;
}
:host .ql-bubble .ql-hidden {
  display: none;
}
:host .ql-bubble .ql-out-bottom,
:host .ql-bubble .ql-out-top {
  visibility: hidden;
}
:host .ql-bubble .ql-tooltip {
  position: absolute;
  transform: translateY(10px);
}
:host .ql-bubble .ql-tooltip a {
  cursor: pointer;
  text-decoration: none;
}
:host .ql-bubble .ql-tooltip.ql-flip {
  transform: translateY(-10px);
}
:host .ql-bubble .ql-formats {
  display: inline-block;
  vertical-align: middle;
}
:host .ql-bubble .ql-formats:after {
  clear: both;
  content: "";
  display: table;
}
:host .ql-bubble .ql-stroke {
  fill: none;
  stroke: #ccc;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}
:host .ql-bubble .ql-stroke-miter {
  fill: none;
  stroke: #ccc;
  stroke-miterlimit: 10;
  stroke-width: 2;
}
:host .ql-bubble .ql-fill,
:host .ql-bubble .ql-stroke.ql-fill {
  fill: #ccc;
}
:host .ql-bubble .ql-empty {
  fill: none;
}
:host .ql-bubble .ql-even {
  fill-rule: evenodd;
}
:host .ql-bubble .ql-thin,
:host .ql-bubble .ql-stroke.ql-thin {
  stroke-width: 1;
}
:host .ql-bubble .ql-transparent {
  opacity: 0.4;
}
:host .ql-bubble .ql-direction svg:last-child {
  display: none;
}
:host .ql-bubble .ql-direction.ql-active svg:last-child {
  display: inline;
}
:host .ql-bubble .ql-direction.ql-active svg:first-child {
  display: none;
}
:host .ql-bubble .ql-editor h1 {
  font-size: 2em;
}
:host .ql-bubble .ql-editor h2 {
  font-size: 1.5em;
}
:host .ql-bubble .ql-editor h3 {
  font-size: 1.17em;
}
:host .ql-bubble .ql-editor h4 {
  font-size: 1em;
}
:host .ql-bubble .ql-editor h5 {
  font-size: 0.83em;
}
:host .ql-bubble .ql-editor h6 {
  font-size: 0.67em;
}
:host .ql-bubble .ql-editor a {
  text-decoration: underline;
}
:host .ql-bubble .ql-editor blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}
:host .ql-bubble .ql-editor code,
:host .ql-bubble .ql-editor pre {
  background-color: #f0f0f0;
  border-radius: 3px;
}
:host .ql-bubble .ql-editor pre {
  white-space: pre-wrap;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px;
}
:host .ql-bubble .ql-editor code {
  font-size: 85%;
  padding: 2px 4px;
}
:host .ql-bubble .ql-editor pre.ql-syntax {
  background-color: #23241f;
  color: #f8f8f2;
  overflow: visible;
}
:host .ql-bubble .ql-editor img {
  max-width: 100%;
}
:host .ql-bubble .ql-picker {
  color: #ccc;
  display: inline-block;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 24px;
  position: relative;
  vertical-align: middle;
}
:host .ql-bubble .ql-picker-label {
  cursor: pointer;
  display: inline-block;
  height: 100%;
  padding-left: 8px;
  padding-right: 2px;
  position: relative;
  width: 100%;
}
:host .ql-bubble .ql-picker-label::before {
  display: inline-block;
  line-height: 22px;
}
:host .ql-bubble .ql-picker-options {
  background-color: #444;
  display: none;
  min-width: 100%;
  padding: 4px 8px;
  position: absolute;
  white-space: nowrap;
}
:host .ql-bubble .ql-picker-options .ql-picker-item {
  cursor: pointer;
  display: block;
  padding-bottom: 5px;
  padding-top: 5px;
}
:host .ql-bubble .ql-picker.ql-expanded .ql-picker-label {
  color: #777;
  z-index: 2;
}
:host .ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #777;
}
:host .ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #777;
}
:host .ql-bubble .ql-picker.ql-expanded .ql-picker-options {
  display: block;
  margin-top: -1px;
  top: 100%;
  z-index: 1;
}
:host .ql-bubble .ql-color-picker,
:host .ql-bubble .ql-icon-picker {
  width: 28px;
}
:host .ql-bubble .ql-color-picker .ql-picker-label,
:host .ql-bubble .ql-icon-picker .ql-picker-label {
  padding: 2px 4px;
}
:host .ql-bubble .ql-color-picker .ql-picker-label svg,
:host .ql-bubble .ql-icon-picker .ql-picker-label svg {
  right: 4px;
}
:host .ql-bubble .ql-icon-picker .ql-picker-options {
  padding: 4px 0px;
}
:host .ql-bubble .ql-icon-picker .ql-picker-item {
  height: 24px;
  width: 24px;
  padding: 2px 4px;
}
:host .ql-bubble .ql-color-picker .ql-picker-options {
  padding: 3px 5px;
  width: 152px;
}
:host .ql-bubble .ql-color-picker .ql-picker-item {
  border: 1px solid transparent;
  float: left;
  height: 16px;
  margin: 2px;
  padding: 0px;
  width: 16px;
}
:host .ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  position: absolute;
  margin-top: -9px;
  right: 0;
  top: 50%;
  width: 18px;
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=""])::before,
:host .ql-bubble .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=""])::before,
:host .ql-bubble .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=""])::before,
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=""])::before,
:host .ql-bubble .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=""])::before,
:host .ql-bubble .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=""])::before {
  content: attr(data-label);
}
:host .ql-bubble .ql-picker.ql-header {
  width: 98px;
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-label::before,
:host .ql-bubble .ql-picker.ql-header .ql-picker-item::before {
  content: "Normal";
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "Heading 1";
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "Heading 2";
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "Heading 3";
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "Heading 4";
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "Heading 5";
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "Heading 6";
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  font-size: 2em;
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  font-size: 1.5em;
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  font-size: 1.17em;
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  font-size: 1em;
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  font-size: 0.83em;
}
:host .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  font-size: 0.67em;
}
:host .ql-bubble .ql-picker.ql-font {
  width: 108px;
}
:host .ql-bubble .ql-picker.ql-font .ql-picker-label::before,
:host .ql-bubble .ql-picker.ql-font .ql-picker-item::before {
  content: "Sans Serif";
}
:host .ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
:host .ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: "Serif";
}
:host .ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
:host .ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: "Monospace";
}
:host .ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  font-family: Georgia, Times New Roman, serif;
}
:host .ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  font-family: Monaco, Courier New, monospace;
}
:host .ql-bubble .ql-picker.ql-size {
  width: 98px;
}
:host .ql-bubble .ql-picker.ql-size .ql-picker-label::before,
:host .ql-bubble .ql-picker.ql-size .ql-picker-item::before {
  content: "Normal";
}
:host .ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
:host .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: "Small";
}
:host .ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
:host .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: "Large";
}
:host .ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
:host .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: "Huge";
}
:host .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  font-size: 10px;
}
:host .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  font-size: 18px;
}
:host .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  font-size: 32px;
}
:host .ql-bubble .ql-color-picker.ql-background .ql-picker-item {
  background-color: #fff;
}
:host .ql-bubble .ql-color-picker.ql-color .ql-picker-item {
  background-color: #000;
}
:host .ql-bubble .ql-toolbar .ql-formats {
  margin: 8px 12px 8px 0px;
}
:host .ql-bubble .ql-toolbar .ql-formats:first-child {
  margin-left: 12px;
}
:host .ql-bubble .ql-color-picker svg {
  margin: 1px;
}
:host .ql-bubble .ql-color-picker .ql-picker-item.ql-selected,
:host .ql-bubble .ql-color-picker .ql-picker-item:hover {
  border-color: #fff;
}
:host .ql-bubble .ql-tooltip {
  background-color: #444;
  border-radius: 25px;
  color: #fff;
}
:host .ql-bubble .ql-tooltip-arrow {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  content: " ";
  display: block;
  left: 50%;
  margin-left: -6px;
  position: absolute;
}
:host .ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow {
  border-bottom: 6px solid #444;
  top: -6px;
}
:host .ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow {
  border-top: 6px solid #444;
  bottom: -6px;
}
:host .ql-bubble .ql-tooltip.ql-editing .ql-tooltip-editor {
  display: block;
}
:host .ql-bubble .ql-tooltip.ql-editing .ql-formats {
  visibility: hidden;
}
:host .ql-bubble .ql-tooltip-editor {
  display: none;
}
:host .ql-bubble .ql-tooltip-editor input[type=text] {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 13px;
  height: 100%;
  outline: none;
  padding: 10px 20px;
  position: absolute;
  width: 100%;
}
:host .ql-bubble .ql-tooltip-editor a {
  top: 10px;
  position: absolute;
  right: 20px;
}
:host .ql-bubble .ql-tooltip-editor a:before {
  color: #ccc;
  content: "×";
  font-size: 16px;
  font-weight: bold;
}
:host .ql-container.ql-bubble:not(.ql-disabled) a {
  position: relative;
  white-space: nowrap;
}
:host .ql-container.ql-bubble:not(.ql-disabled) a::before {
  background-color: #444;
  border-radius: 15px;
  top: -5px;
  font-size: 12px;
  color: #fff;
  content: attr(href);
  font-weight: normal;
  overflow: hidden;
  padding: 5px 15px;
  text-decoration: none;
  z-index: 1;
}
:host .ql-container.ql-bubble:not(.ql-disabled) a::after {
  border-top: 6px solid #444;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  top: 0;
  content: " ";
  height: 0;
  width: 0;
}
:host .ql-container.ql-bubble:not(.ql-disabled) a::before,
:host .ql-container.ql-bubble:not(.ql-disabled) a::after {
  left: 0;
  margin-left: 50%;
  position: absolute;
  transform: translate(-50%, -100%);
  transition: visibility 0s ease 200ms;
  visibility: hidden;
}
:host .ql-container.ql-bubble:not(.ql-disabled) a:hover::before,
:host .ql-container.ql-bubble:not(.ql-disabled) a:hover::after {
  visibility: visible;
}
:host .ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}
:host .ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
:host .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
  pointer-events: none;
}
:host .ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
:host .ql-clipboard p {
  margin: 0;
  padding: 0;
}
:host .ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
:host .ql-editor > * {
  cursor: text;
}
:host .ql-editor p,
:host .ql-editor ol,
:host .ql-editor ul,
:host .ql-editor pre,
:host .ql-editor blockquote,
:host .ql-editor h1,
:host .ql-editor h2,
:host .ql-editor h3,
:host .ql-editor h4,
:host .ql-editor h5,
:host .ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol,
:host .ql-editor ul {
  padding-left: 1.5em;
}
:host .ql-editor ol > li,
:host .ql-editor ul > li {
  list-style-type: none;
}
:host .ql-editor ul > li::before {
  content: "•";
}
:host .ql-editor ul[data-checked=true],
:host .ql-editor ul[data-checked=false] {
  pointer-events: none;
}
:host .ql-editor ul[data-checked=true] > li *,
:host .ql-editor ul[data-checked=false] > li * {
  pointer-events: all;
}
:host .ql-editor ul[data-checked=true] > li::before,
:host .ql-editor ul[data-checked=false] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
:host .ql-editor ul[data-checked=true] > li::before {
  content: "☑";
}
:host .ql-editor ul[data-checked=false] > li::before {
  content: "☐";
}
:host .ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
:host .ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
:host .ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
:host .ql-editor ol li:not(.ql-direction-rtl),
:host .ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
:host .ql-editor ol li.ql-direction-rtl,
:host .ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
:host .ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
:host .ql-editor ol li:before {
  content: counter(list-0, decimal) ". ";
}
:host .ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
:host .ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}
:host .ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
:host .ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}
:host .ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}
:host .ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}
:host .ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}
:host .ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}
:host .ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}
:host .ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}
:host .ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}
:host .ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}
:host .ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
:host .ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}
:host .ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}
:host .ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
:host .ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}
:host .ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}
:host .ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}
:host .ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}
:host .ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}
:host .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
:host .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
:host .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
:host .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
:host .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
:host .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
:host .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
:host .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
:host .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
:host .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
:host .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
:host .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
:host .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
:host .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
:host .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
:host .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
:host .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
:host .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
:host .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
:host .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
:host .ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
:host .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
:host .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
:host .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
:host .ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
:host .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
:host .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
:host .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
:host .ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
:host .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
:host .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
:host .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
:host .ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
:host .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
:host .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
:host .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
:host .ql-editor .ql-video {
  display: block;
  max-width: 100%;
}
:host .ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}
:host .ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
:host .ql-editor .ql-bg-black {
  background-color: #000;
}
:host .ql-editor .ql-bg-red {
  background-color: #e60000;
}
:host .ql-editor .ql-bg-orange {
  background-color: #f90;
}
:host .ql-editor .ql-bg-yellow {
  background-color: #ff0;
}
:host .ql-editor .ql-bg-green {
  background-color: #008a00;
}
:host .ql-editor .ql-bg-blue {
  background-color: #06c;
}
:host .ql-editor .ql-bg-purple {
  background-color: #93f;
}
:host .ql-editor .ql-color-white {
  color: #fff;
}
:host .ql-editor .ql-color-red {
  color: #e60000;
}
:host .ql-editor .ql-color-orange {
  color: #f90;
}
:host .ql-editor .ql-color-yellow {
  color: #ff0;
}
:host .ql-editor .ql-color-green {
  color: #008a00;
}
:host .ql-editor .ql-color-blue {
  color: #06c;
}
:host .ql-editor .ql-color-purple {
  color: #93f;
}
:host .ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
:host .ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
:host .ql-editor .ql-size-small {
  font-size: 0.75em;
}
:host .ql-editor .ql-size-large {
  font-size: 1.5em;
}
:host .ql-editor .ql-size-huge {
  font-size: 2.5em;
}
:host .ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
:host .ql-editor .ql-align-center {
  text-align: center;
}
:host .ql-editor .ql-align-justify {
  text-align: justify;
}
:host .ql-editor .ql-align-right {
  text-align: right;
}
:host .ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}
:host .ql-snow.ql-toolbar:after,
:host .ql-snow .ql-toolbar:after {
  clear: both;
  content: "";
  display: table;
}
:host .ql-snow.ql-toolbar button,
:host .ql-snow .ql-toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  padding: 3px 5px;
  width: 28px;
}
:host .ql-snow.ql-toolbar button svg,
:host .ql-snow .ql-toolbar button svg {
  float: left;
  height: 100%;
}
:host .ql-snow.ql-toolbar button:active:hover,
:host .ql-snow .ql-toolbar button:active:hover {
  outline: none;
}
:host .ql-snow.ql-toolbar input.ql-image[type=file],
:host .ql-snow .ql-toolbar input.ql-image[type=file] {
  display: none;
}
:host .ql-snow.ql-toolbar button:hover,
:host .ql-snow .ql-toolbar button:hover,
:host .ql-snow.ql-toolbar button:focus,
:host .ql-snow .ql-toolbar button:focus,
:host .ql-snow.ql-toolbar button.ql-active,
:host .ql-snow .ql-toolbar button.ql-active,
:host .ql-snow.ql-toolbar .ql-picker-label:hover,
:host .ql-snow .ql-toolbar .ql-picker-label:hover,
:host .ql-snow.ql-toolbar .ql-picker-label.ql-active,
:host .ql-snow .ql-toolbar .ql-picker-label.ql-active,
:host .ql-snow.ql-toolbar .ql-picker-item:hover,
:host .ql-snow .ql-toolbar .ql-picker-item:hover,
:host .ql-snow.ql-toolbar .ql-picker-item.ql-selected,
:host .ql-snow .ql-toolbar .ql-picker-item.ql-selected {
  color: #06c;
}
:host .ql-snow.ql-toolbar button:hover .ql-fill,
:host .ql-snow .ql-toolbar button:hover .ql-fill,
:host .ql-snow.ql-toolbar button:focus .ql-fill,
:host .ql-snow .ql-toolbar button:focus .ql-fill,
:host .ql-snow.ql-toolbar button.ql-active .ql-fill,
:host .ql-snow .ql-toolbar button.ql-active .ql-fill,
:host .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
:host .ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
:host .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
:host .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
:host .ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
:host .ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
:host .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
:host .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
:host .ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
:host .ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
:host .ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
:host .ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
:host .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
:host .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
:host .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
:host .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
:host .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
:host .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
:host .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
:host .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
:host .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
:host .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: #06c;
}
:host .ql-snow.ql-toolbar button:hover .ql-stroke,
:host .ql-snow .ql-toolbar button:hover .ql-stroke,
:host .ql-snow.ql-toolbar button:focus .ql-stroke,
:host .ql-snow .ql-toolbar button:focus .ql-stroke,
:host .ql-snow.ql-toolbar button.ql-active .ql-stroke,
:host .ql-snow .ql-toolbar button.ql-active .ql-stroke,
:host .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
:host .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
:host .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
:host .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
:host .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
:host .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
:host .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
:host .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
:host .ql-snow.ql-toolbar button:hover .ql-stroke-miter,
:host .ql-snow .ql-toolbar button:hover .ql-stroke-miter,
:host .ql-snow.ql-toolbar button:focus .ql-stroke-miter,
:host .ql-snow .ql-toolbar button:focus .ql-stroke-miter,
:host .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
:host .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
:host .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
:host .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
:host .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
:host .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
:host .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
:host .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
:host .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
:host .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
  stroke: #06c;
}
@media (pointer: coarse) {
  :host .ql-snow.ql-toolbar button:hover:not(.ql-active),
  :host .ql-snow .ql-toolbar button:hover:not(.ql-active) {
    color: #444;
  }
  :host .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,
  :host .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,
  :host .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
  :host .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
    fill: #444;
  }
  :host .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  :host .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  :host .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
  :host .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
    stroke: #444;
  }
}
:host .ql-snow {
  box-sizing: border-box;
}
:host .ql-snow * {
  box-sizing: border-box;
}
:host .ql-snow .ql-hidden {
  display: none;
}
:host .ql-snow .ql-out-bottom,
:host .ql-snow .ql-out-top {
  visibility: hidden;
}
:host .ql-snow .ql-tooltip {
  position: absolute;
  transform: translateY(10px);
}
:host .ql-snow .ql-tooltip a {
  cursor: pointer;
  text-decoration: none;
}
:host .ql-snow .ql-tooltip.ql-flip {
  transform: translateY(-10px);
}
:host .ql-snow .ql-formats {
  display: inline-block;
  vertical-align: middle;
}
:host .ql-snow .ql-formats:after {
  clear: both;
  content: "";
  display: table;
}
:host .ql-snow .ql-stroke {
  fill: none;
  stroke: #444;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}
:host .ql-snow .ql-stroke-miter {
  fill: none;
  stroke: #444;
  stroke-miterlimit: 10;
  stroke-width: 2;
}
:host .ql-snow .ql-fill,
:host .ql-snow .ql-stroke.ql-fill {
  fill: #444;
}
:host .ql-snow .ql-empty {
  fill: none;
}
:host .ql-snow .ql-even {
  fill-rule: evenodd;
}
:host .ql-snow .ql-thin,
:host .ql-snow .ql-stroke.ql-thin {
  stroke-width: 1;
}
:host .ql-snow .ql-transparent {
  opacity: 0.4;
}
:host .ql-snow .ql-direction svg:last-child {
  display: none;
}
:host .ql-snow .ql-direction.ql-active svg:last-child {
  display: inline;
}
:host .ql-snow .ql-direction.ql-active svg:first-child {
  display: none;
}
:host .ql-snow .ql-editor h1 {
  font-size: 2em;
}
:host .ql-snow .ql-editor h2 {
  font-size: 1.5em;
}
:host .ql-snow .ql-editor h3 {
  font-size: 1.17em;
}
:host .ql-snow .ql-editor h4 {
  font-size: 1em;
}
:host .ql-snow .ql-editor h5 {
  font-size: 0.83em;
}
:host .ql-snow .ql-editor h6 {
  font-size: 0.67em;
}
:host .ql-snow .ql-editor a {
  text-decoration: underline;
}
:host .ql-snow .ql-editor blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}
:host .ql-snow .ql-editor code,
:host .ql-snow .ql-editor pre {
  background-color: #f0f0f0;
  border-radius: 3px;
}
:host .ql-snow .ql-editor pre {
  white-space: pre-wrap;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px;
}
:host .ql-snow .ql-editor code {
  font-size: 85%;
  padding: 2px 4px;
}
:host .ql-snow .ql-editor pre.ql-syntax {
  background-color: #23241f;
  color: #f8f8f2;
  overflow: visible;
}
:host .ql-snow .ql-editor img {
  max-width: 100%;
}
:host .ql-snow .ql-picker {
  color: #444;
  display: inline-block;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 24px;
  position: relative;
  vertical-align: middle;
}
:host .ql-snow .ql-picker-label {
  cursor: pointer;
  display: inline-block;
  height: 100%;
  padding-left: 8px;
  padding-right: 2px;
  position: relative;
  width: 100%;
}
:host .ql-snow .ql-picker-label::before {
  display: inline-block;
  line-height: 22px;
}
:host .ql-snow .ql-picker-options {
  background-color: #fff;
  display: none;
  min-width: 100%;
  padding: 4px 8px;
  position: absolute;
  white-space: nowrap;
}
:host .ql-snow .ql-picker-options .ql-picker-item {
  cursor: pointer;
  display: block;
  padding-bottom: 5px;
  padding-top: 5px;
}
:host .ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: #ccc;
  z-index: 2;
}
:host .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #ccc;
}
:host .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #ccc;
}
:host .ql-snow .ql-picker.ql-expanded .ql-picker-options {
  display: block;
  margin-top: -1px;
  top: 100%;
  z-index: 1;
}
:host .ql-snow .ql-color-picker,
:host .ql-snow .ql-icon-picker {
  width: 28px;
}
:host .ql-snow .ql-color-picker .ql-picker-label,
:host .ql-snow .ql-icon-picker .ql-picker-label {
  padding: 2px 4px;
}
:host .ql-snow .ql-color-picker .ql-picker-label svg,
:host .ql-snow .ql-icon-picker .ql-picker-label svg {
  right: 4px;
}
:host .ql-snow .ql-icon-picker .ql-picker-options {
  padding: 4px 0px;
}
:host .ql-snow .ql-icon-picker .ql-picker-item {
  height: 24px;
  width: 24px;
  padding: 2px 4px;
}
:host .ql-snow .ql-color-picker .ql-picker-options {
  padding: 3px 5px;
  width: 152px;
}
:host .ql-snow .ql-color-picker .ql-picker-item {
  border: 1px solid transparent;
  float: left;
  height: 16px;
  margin: 2px;
  padding: 0px;
  width: 16px;
}
:host .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  position: absolute;
  margin-top: -9px;
  right: 0;
  top: 50%;
  width: 18px;
}
:host .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=""])::before,
:host .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=""])::before,
:host .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=""])::before,
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=""])::before,
:host .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=""])::before,
:host .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=""])::before {
  content: attr(data-label);
}
:host .ql-snow .ql-picker.ql-header {
  width: 98px;
}
:host .ql-snow .ql-picker.ql-header .ql-picker-label::before,
:host .ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "Normal";
}
:host .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "Heading 1";
}
:host .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "Heading 2";
}
:host .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "Heading 3";
}
:host .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "Heading 4";
}
:host .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "Heading 5";
}
:host .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "Heading 6";
}
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  font-size: 2em;
}
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  font-size: 1.5em;
}
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  font-size: 1.17em;
}
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  font-size: 1em;
}
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  font-size: 0.83em;
}
:host .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  font-size: 0.67em;
}
:host .ql-snow .ql-picker.ql-font {
  width: 108px;
}
:host .ql-snow .ql-picker.ql-font .ql-picker-label::before,
:host .ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "Sans Serif";
}
:host .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
:host .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: "Serif";
}
:host .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
:host .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: "Monospace";
}
:host .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  font-family: Georgia, Times New Roman, serif;
}
:host .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  font-family: Monaco, Courier New, monospace;
}
:host .ql-snow .ql-picker.ql-size {
  width: 98px;
}
:host .ql-snow .ql-picker.ql-size .ql-picker-label::before,
:host .ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "Normal";
}
:host .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
:host .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: "Small";
}
:host .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
:host .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: "Large";
}
:host .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
:host .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: "Huge";
}
:host .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  font-size: 10px;
}
:host .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  font-size: 18px;
}
:host .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  font-size: 32px;
}
:host .ql-snow .ql-color-picker.ql-background .ql-picker-item {
  background-color: #fff;
}
:host .ql-snow .ql-color-picker.ql-color .ql-picker-item {
  background-color: #000;
}
:host .ql-toolbar.ql-snow {
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  padding: 8px;
}
:host .ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
}
:host .ql-toolbar.ql-snow .ql-picker-label {
  border: 1px solid transparent;
}
:host .ql-toolbar.ql-snow .ql-picker-options {
  border: 1px solid transparent;
  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;
}
:host .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: #ccc;
}
:host .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  border-color: #ccc;
}
:host .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
:host .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
  border-color: #000;
}
:host .ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
}
:host .ql-snow .ql-tooltip {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 5px #ddd;
  color: #444;
  padding: 5px 12px;
  white-space: nowrap;
}
:host .ql-snow .ql-tooltip::before {
  content: "Visit URL:";
  line-height: 26px;
  margin-right: 8px;
}
:host .ql-snow .ql-tooltip input[type=text] {
  display: none;
  border: 1px solid #ccc;
  font-size: 13px;
  height: 26px;
  margin: 0px;
  padding: 3px 5px;
  width: 170px;
}
:host .ql-snow .ql-tooltip a.ql-preview {
  display: inline-block;
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}
:host .ql-snow .ql-tooltip a.ql-action::after {
  border-right: 1px solid #ccc;
  content: "Edit";
  margin-left: 16px;
  padding-right: 8px;
}
:host .ql-snow .ql-tooltip a.ql-remove::before {
  content: "Remove";
  margin-left: 8px;
}
:host .ql-snow .ql-tooltip a {
  line-height: 26px;
}
:host .ql-snow .ql-tooltip.ql-editing a.ql-preview,
:host .ql-snow .ql-tooltip.ql-editing a.ql-remove {
  display: none;
}
:host .ql-snow .ql-tooltip.ql-editing input[type=text] {
  display: inline-block;
}
:host .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "Save";
  padding-right: 0px;
}
:host .ql-snow .ql-tooltip[data-mode=link]::before {
  content: "Enter link:";
}
:host .ql-snow .ql-tooltip[data-mode=formula]::before {
  content: "Enter formula:";
}
:host .ql-snow .ql-tooltip[data-mode=video]::before {
  content: "Enter video:";
}
:host .ql-snow a {
  color: #06c;
}
:host .ql-container.ql-snow {
  border: 1px solid #ccc;
}
:host .alert-radio-label {
  white-space: normal !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/blog-pages/blog-add-item/blog-add-item.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EA0bE;;;;;IAAA;EAw7BA;;;;;IAAA;AAp2CF;AAbE;EACE,yBAAA;EACA,iBAAA;AAeJ;AAZE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;AAcJ;AAZI;EACE,kBAAA;EACA,WAAA;AAcN;AAXI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;EACA,+BAAA;EACA,WAAA;AAaN;AAVI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAYN;AAPI;EACE,kBAAA;AASN;AALE;EACE,sBAAA;EACA,yCAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;AALE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAOJ;AALE;EACE,SAAA;EACA,UAAA;AAOJ;AALE;EACE,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AAOJ;AALE;EACE,YAAA;AAOJ;AALE;;;;;;;;;;;EAWE,SAAA;EACA,UAAA;EACA,6EAAA;AAOJ;AALE;;EAEE,mBAAA;AAOJ;AALE;;EAEE,qBAAA;AAOJ;AALE;EACE,YAAA;AAOJ;AALE;;EAEE,oBAAA;AAOJ;AALE;;EAEE,mBAAA;AAOJ;AALE;;EAEE,WAAA;EACA,eAAA;EACA,mBAAA;AAOJ;AALE;EACE,YAAA;AAOJ;AALE;EACE,YAAA;AAOJ;AALE;EACE,qBAAA;EACA,mBAAA;EACA,YAAA;AAOJ;AALE;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;AAOJ;AALE;EACE,kBAAA;EACA,oBAAA;AAOJ;AALE;;EAEE,mBAAA;AAOJ;AALE;;EAEE,oBAAA;AAOJ;AALE;EACE,6EAAA;EACA,yBAAA;AAOJ;AALE;EACE,sCAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,0CAAA;AAOJ;AALE;EACE,sEAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,0CAAA;AAOJ;AALE;EACE,+DAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,sCAAA;AAOJ;AALE;EACE,wDAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,0CAAA;AAOJ;AALE;EACE,iDAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,0CAAA;AAOJ;AALE;EACE,0CAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,sCAAA;AAOJ;AALE;EACE,mCAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,0CAAA;AAOJ;AALE;EACE,4BAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,0CAAA;AAOJ;AALE;EACE,qBAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,sCAAA;AAOJ;AALE;EACE,iBAAA;AAOJ;AALE;EACE,mBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;AALE;EACE,iBAAA;AAOJ;AALE;EACE,mBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;AALE;EACE,iBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,qBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;AALE;EACE,mBAAA;AAOJ;AALE;EACE,qBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;AALE;EACE,mBAAA;AAOJ;AALE;EACE,qBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;AALE;EACE,mBAAA;AAOJ;AALE;EACE,qBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;AALE;EACE,mBAAA;AAOJ;AALE;EACE,qBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;AALE;EACE,mBAAA;AAOJ;AALE;EACE,qBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;AALE;EACE,mBAAA;AAOJ;AALE;EACE,qBAAA;AAOJ;AALE;EACE,cAAA;EACA,eAAA;AAOJ;AALE;EACE,cAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,sBAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,sBAAA;AAOJ;AALE;EACE,sBAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AALE;EACE,sBAAA;AAOJ;AALE;EACE,sBAAA;AAOJ;AALE;EACE,WAAA;AAOJ;AALE;EACE,cAAA;AAOJ;AALE;EACE,WAAA;AAOJ;AALE;EACE,WAAA;AAOJ;AALE;EACE,cAAA;AAOJ;AALE;EACE,WAAA;AAOJ;AALE;EACE,WAAA;AAOJ;AALE;EACE,4CAAA;AAOJ;AALE;EACE,2CAAA;AAOJ;AALE;EACE,iBAAA;AAOJ;AALE;EACE,gBAAA;AAOJ;AALE;EACE,gBAAA;AAOJ;AALE;EACE,cAAA;EACA,mBAAA;AAOJ;AALE;EACE,kBAAA;AAOJ;AALE;EACE,mBAAA;AAOJ;AALE;EACE,iBAAA;AAOJ;AALE;EACE,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AAOJ;AACE;EACE,sBAAA;EACA,yCAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,oBAAA;AACJ;AACE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AACJ;AACE;EACE,SAAA;EACA,UAAA;AACJ;AACE;EACE,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AACJ;AACE;EACE,YAAA;AACJ;AACE;;;;;;;;;;;EAWE,SAAA;EACA,UAAA;EACA,6EAAA;AACJ;AACE;;EAEE,mBAAA;AACJ;AACE;;EAEE,qBAAA;AACJ;AACE;EACE,YAAA;AACJ;AACE;;EAEE,oBAAA;AACJ;AACE;;EAEE,mBAAA;AACJ;AACE;;EAEE,WAAA;EACA,eAAA;EACA,mBAAA;AACJ;AACE;EACE,YAAA;AACJ;AACE;EACE,YAAA;AACJ;AACE;EACE,qBAAA;EACA,mBAAA;EACA,YAAA;AACJ;AACE;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;AACE;EACE,kBAAA;EACA,oBAAA;AACJ;AACE;;EAEE,mBAAA;AACJ;AACE;;EAEE,oBAAA;AACJ;AACE;EACE,6EAAA;EACA,yBAAA;AACJ;AACE;EACE,sCAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,0CAAA;AACJ;AACE;EACE,sEAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,0CAAA;AACJ;AACE;EACE,+DAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,sCAAA;AACJ;AACE;EACE,wDAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,0CAAA;AACJ;AACE;EACE,iDAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,0CAAA;AACJ;AACE;EACE,0CAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,sCAAA;AACJ;AACE;EACE,mCAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,0CAAA;AACJ;AACE;EACE,4BAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,0CAAA;AACJ;AACE;EACE,qBAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,sCAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,mBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,oBAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,mBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,oBAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,oBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,qBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,oBAAA;AACJ;AACE;EACE,mBAAA;AACJ;AACE;EACE,qBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,oBAAA;AACJ;AACE;EACE,mBAAA;AACJ;AACE;EACE,qBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,oBAAA;AACJ;AACE;EACE,mBAAA;AACJ;AACE;EACE,qBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,oBAAA;AACJ;AACE;EACE,mBAAA;AACJ;AACE;EACE,qBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,oBAAA;AACJ;AACE;EACE,mBAAA;AACJ;AACE;EACE,qBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,oBAAA;AACJ;AACE;EACE,mBAAA;AACJ;AACE;EACE,qBAAA;AACJ;AACE;EACE,cAAA;EACA,eAAA;AACJ;AACE;EACE,cAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,sBAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,sBAAA;AACJ;AACE;EACE,sBAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,sBAAA;AACJ;AACE;EACE,sBAAA;AACJ;AACE;EACE,WAAA;AACJ;AACE;EACE,cAAA;AACJ;AACE;EACE,WAAA;AACJ;AACE;EACE,WAAA;AACJ;AACE;EACE,cAAA;AACJ;AACE;EACE,WAAA;AACJ;AACE;EACE,WAAA;AACJ;AACE;EACE,4CAAA;AACJ;AACE;EACE,2CAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,gBAAA;AACJ;AACE;EACE,gBAAA;AACJ;AACE;EACE,cAAA;EACA,mBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,mBAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AACJ;AACE;;EAEE,WAAA;EACA,WAAA;EACA,cAAA;AACJ;AACE;;EAEE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AACJ;AACE;;EAEE,WAAA;EACA,YAAA;AACJ;AACE;;EAEE,aAAA;AACJ;AACE;;EAEE,aAAA;AACJ;AACE;;;;;;;;;;;;;;EAcE,WAAA;AACJ;AACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,UAAA;AACJ;AACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,YAAA;AACJ;AACE;EACE;;IAEE,WAAA;EACJ;EACE;;;;IAIE,UAAA;EACJ;EACE;;;;IAIE,YAAA;EACJ;AACF;AACE;EACE,sBAAA;AACJ;AACE;EACE,sBAAA;AACJ;AACE;EACE,aAAA;AACJ;AACE;;EAEE,kBAAA;AACJ;AACE;EACE,kBAAA;EACA,2BAAA;AACJ;AACE;EACE,eAAA;EACA,qBAAA;AACJ;AACE;EACE,4BAAA;AACJ;AACE;EACE,qBAAA;EACA,sBAAA;AACJ;AACE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AACJ;AACE;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AACJ;AACE;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AACJ;AACE;;EAEE,UAAA;AACJ;AACE;EACE,UAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;;EAEE,eAAA;AACJ;AACE;EACE,YAAA;AACJ;AACE;EACE,aAAA;AACJ;AACE;EACE,eAAA;AACJ;AACE;EACE,aAAA;AACJ;AACE;EACE,cAAA;AACJ;AACE;EACE,gBAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,cAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,0BAAA;AACJ;AACE;EACE,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AACJ;AACE;;EAEE,yBAAA;EACA,kBAAA;AACJ;AACE;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AACJ;AACE;EACE,cAAA;EACA,gBAAA;AACJ;AACE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AACJ;AACE;EACE,eAAA;AACJ;AACE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AACJ;AACE;EACE,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AACJ;AACE;EACE,qBAAA;EACA,iBAAA;AACJ;AACE;EACE,sBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;AACE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACE;EACE,WAAA;EACA,UAAA;AACJ;AACE;EACE,UAAA;AACJ;AACE;EACE,YAAA;AACJ;AACE;EACE,cAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AACJ;AACE;;EAEE,WAAA;AACJ;AACE;;EAEE,gBAAA;AACJ;AACE;;EAEE,UAAA;AACJ;AACE;EACE,gBAAA;AACJ;AACE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AACJ;AACE;EACE,gBAAA;EACA,YAAA;AACJ;AACE;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AACJ;AACE;EACE,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;AACJ;AACE;;;;;;EAME,yBAAA;AACJ;AACE;EACE,WAAA;AACJ;AACE;;EAEE,iBAAA;AACJ;AACE;;EAEE,oBAAA;AACJ;AACE;;EAEE,oBAAA;AACJ;AACE;;EAEE,oBAAA;AACJ;AACE;;EAEE,oBAAA;AACJ;AACE;;EAEE,oBAAA;AACJ;AACE;;EAEE,oBAAA;AACJ;AACE;EACE,cAAA;AACJ;AACE;EACE,gBAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,cAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,YAAA;AACJ;AACE;;EAEE,qBAAA;AACJ;AACE;;EAEE,gBAAA;AACJ;AACE;;EAEE,oBAAA;AACJ;AACE;EACE,4CAAA;AACJ;AACE;EACE,2CAAA;AACJ;AACE;EACE,WAAA;AACJ;AACE;;EAEE,iBAAA;AACJ;AACE;;EAEE,gBAAA;AACJ;AACE;;EAEE,gBAAA;AACJ;AACE;;EAEE,eAAA;AACJ;AACE;EACE,eAAA;AACJ;AACE;EACE,eAAA;AACJ;AACE;EACE,eAAA;AACJ;AACE;EACE,sBAAA;AACJ;AACE;EACE,sBAAA;AACJ;AACE;EACE,wBAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,WAAA;AACJ;AACE;;EAEE,kBAAA;AACJ;AACE;EACE,sBAAA;EACA,mBAAA;EACA,WAAA;AACJ;AACE;EACE,kCAAA;EACA,mCAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AACE;EACE,6BAAA;EACA,SAAA;AACJ;AACE;EACE,0BAAA;EACA,YAAA;AACJ;AACE;EACE,cAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,aAAA;AACJ;AACE;EACE,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AACJ;AACE;EACE,SAAA;EACA,kBAAA;EACA,WAAA;AACJ;AACE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AACJ;AACE;EACE,kBAAA;EACA,mBAAA;AACJ;AACE;EACE,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,UAAA;AACJ;AACE;EACE,0BAAA;EACA,kCAAA;EACA,mCAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AACJ;AACE;;EAEE,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,kBAAA;AACJ;AACE;;EAEE,mBAAA;AACJ;AAOE;EACE,sBAAA;EACA,yCAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AALJ;AAOE;EACE,SAAA;EACA,UAAA;AALJ;AAOE;EACE,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AALJ;AAOE;EACE,YAAA;AALJ;AAOE;;;;;;;;;;;EAWE,SAAA;EACA,UAAA;EACA,6EAAA;AALJ;AAOE;;EAEE,mBAAA;AALJ;AAOE;;EAEE,qBAAA;AALJ;AAOE;EACE,YAAA;AALJ;AAOE;;EAEE,oBAAA;AALJ;AAOE;;EAEE,mBAAA;AALJ;AAOE;;EAEE,WAAA;EACA,eAAA;EACA,mBAAA;AALJ;AAOE;EACE,YAAA;AALJ;AAOE;EACE,YAAA;AALJ;AAOE;EACE,qBAAA;EACA,mBAAA;EACA,YAAA;AALJ;AAOE;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;AALJ;AAOE;EACE,kBAAA;EACA,oBAAA;AALJ;AAOE;;EAEE,mBAAA;AALJ;AAOE;;EAEE,oBAAA;AALJ;AAOE;EACE,6EAAA;EACA,yBAAA;AALJ;AAOE;EACE,sCAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,0CAAA;AALJ;AAOE;EACE,sEAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,0CAAA;AALJ;AAOE;EACE,+DAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,sCAAA;AALJ;AAOE;EACE,wDAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,0CAAA;AALJ;AAOE;EACE,iDAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,0CAAA;AALJ;AAOE;EACE,0CAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,sCAAA;AALJ;AAOE;EACE,mCAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,0CAAA;AALJ;AAOE;EACE,4BAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,0CAAA;AALJ;AAOE;EACE,qBAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,sCAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,qBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,qBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,qBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,qBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,qBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,qBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,qBAAA;AALJ;AAOE;EACE,cAAA;EACA,eAAA;AALJ;AAOE;EACE,cAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,WAAA;AALJ;AAOE;EACE,cAAA;AALJ;AAOE;EACE,WAAA;AALJ;AAOE;EACE,WAAA;AALJ;AAOE;EACE,cAAA;AALJ;AAOE;EACE,WAAA;AALJ;AAOE;EACE,WAAA;AALJ;AAOE;EACE,4CAAA;AALJ;AAOE;EACE,2CAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,gBAAA;AALJ;AAOE;EACE,gBAAA;AALJ;AAOE;EACE,cAAA;EACA,mBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AALJ;AAOE;;EAEE,WAAA;EACA,WAAA;EACA,cAAA;AALJ;AAOE;;EAEE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AALJ;AAOE;;EAEE,WAAA;EACA,YAAA;AALJ;AAOE;;EAEE,aAAA;AALJ;AAOE;;EAEE,aAAA;AALJ;AAOE;;;;;;;;;;;;;;EAcE,WAAA;AALJ;AAOE;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,UAAA;AALJ;AAOE;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,YAAA;AALJ;AAOE;EACE;;IAEE,WAAA;EALJ;EAOE;;;;IAIE,UAAA;EALJ;EAOE;;;;IAIE,YAAA;EALJ;AACF;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,aAAA;AALJ;AAOE;;EAEE,kBAAA;AALJ;AAOE;EACE,kBAAA;EACA,2BAAA;AALJ;AAOE;EACE,eAAA;EACA,qBAAA;AALJ;AAOE;EACE,4BAAA;AALJ;AAOE;EACE,qBAAA;EACA,sBAAA;AALJ;AAOE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AALJ;AAOE;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AALJ;AAOE;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AALJ;AAOE;;EAEE,UAAA;AALJ;AAOE;EACE,UAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;;EAEE,eAAA;AALJ;AAOE;EACE,YAAA;AALJ;AAOE;EACE,aAAA;AALJ;AAOE;EACE,eAAA;AALJ;AAOE;EACE,aAAA;AALJ;AAOE;EACE,cAAA;AALJ;AAOE;EACE,gBAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,cAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,0BAAA;AALJ;AAOE;EACE,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AALJ;AAOE;;EAEE,yBAAA;EACA,kBAAA;AALJ;AAOE;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AALJ;AAOE;EACE,cAAA;EACA,gBAAA;AALJ;AAOE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AALJ;AAOE;EACE,eAAA;AALJ;AAOE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AALJ;AAOE;EACE,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AALJ;AAOE;EACE,qBAAA;EACA,iBAAA;AALJ;AAOE;EACE,sBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AALJ;AAOE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AALJ;AAOE;EACE,WAAA;EACA,UAAA;AALJ;AAOE;EACE,UAAA;AALJ;AAOE;EACE,YAAA;AALJ;AAOE;EACE,cAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AALJ;AAOE;;EAEE,WAAA;AALJ;AAOE;;EAEE,gBAAA;AALJ;AAOE;;EAEE,UAAA;AALJ;AAOE;EACE,gBAAA;AALJ;AAOE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AALJ;AAOE;EACE,gBAAA;EACA,YAAA;AALJ;AAOE;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AALJ;AAOE;EACE,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;AALJ;AAOE;;;;;;EAME,yBAAA;AALJ;AAOE;EACE,WAAA;AALJ;AAOE;;EAEE,iBAAA;AALJ;AAOE;;EAEE,oBAAA;AALJ;AAOE;;EAEE,oBAAA;AALJ;AAOE;;EAEE,oBAAA;AALJ;AAOE;;EAEE,oBAAA;AALJ;AAOE;;EAEE,oBAAA;AALJ;AAOE;;EAEE,oBAAA;AALJ;AAOE;EACE,cAAA;AALJ;AAOE;EACE,gBAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,cAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;EACE,YAAA;AALJ;AAOE;;EAEE,qBAAA;AALJ;AAOE;;EAEE,gBAAA;AALJ;AAOE;;EAEE,oBAAA;AALJ;AAOE;EACE,4CAAA;AALJ;AAOE;EACE,2CAAA;AALJ;AAOE;EACE,WAAA;AALJ;AAOE;;EAEE,iBAAA;AALJ;AAOE;;EAEE,gBAAA;AALJ;AAOE;;EAEE,gBAAA;AALJ;AAOE;;EAEE,eAAA;AALJ;AAOE;EACE,eAAA;AALJ;AAOE;EACE,eAAA;AALJ;AAOE;EACE,eAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,sBAAA;EACA,sBAAA;EACA,+DAAA;EACA,YAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,6BAAA;AALJ;AAOE;EACE,6BAAA;EACA,wCAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,kBAAA;AALJ;AAOE;;EAEE,kBAAA;AALJ;AAOE;EACE,eAAA;AALJ;AAOE;EACE,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AALJ;AAOE;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;AALJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AALJ;AAOE;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AALJ;AAOE;EACE,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AALJ;AAOE;EACE,iBAAA;EACA,gBAAA;AALJ;AAOE;EACE,iBAAA;AALJ;AAOE;;EAEE,aAAA;AALJ;AAOE;EACE,qBAAA;AALJ;AAOE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,yBAAA;AALJ;AAOE;EACE,uBAAA;AALJ;AAOE;EACE,WAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAQE;EACE,8BAAA;AANJ","sourcesContent":[":host {\n  [contenteditable] {\n    -webkit-user-select: text;\n    user-select: text;\n  }\n\n  .photo-placeholder {\n    --padding-start: 0;\n    width: 100%;\n    cursor: pointer;\n    --inner-padding-end: 10px;\n    --inner-padding-start: 10px;\n    --inner-padding-top: 15px;\n    position: relative;\n\n    .photo-container{\n      position: relative;\n      width: 100%;\n    }\n\n    ion-icon {\n      position: absolute;\n      top: 7px;\n      right: 7px;\n      border-radius: 50%;\n      padding: 11px;\n      height: 30px;\n      width: 30px;\n      display: flex !important;\n      align-items: center;\n      justify-content: center;\n      background-color: #f4f5f8;\n      color: var(--cms-button-bg-color);\n      box-shadow: 0 0 8px 3px #151515;\n      z-index: 10;\n    }\n\n    img {\n      width: 100%;\n      max-height: 200px;\n      text-align: center;\n      object-fit: cover;\n    }\n  }\n\n  ion-list {\n    & > ion-label {\n      font-size: inherit;\n    }\n  }\n\n  .ql-container {\n    box-sizing: border-box;\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 13px;\n    height: 100%;\n    margin: 0px;\n    position: relative;\n  }\n  .ql-container.ql-disabled .ql-tooltip {\n    visibility: hidden;\n  }\n  .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n    pointer-events: none;\n  }\n  .ql-clipboard {\n    left: -100000px;\n    height: 1px;\n    overflow-y: hidden;\n    position: absolute;\n    top: 50%;\n  }\n  .ql-clipboard p {\n    margin: 0;\n    padding: 0;\n  }\n  .ql-editor {\n    box-sizing: border-box;\n    line-height: 1.42;\n    height: 100%;\n    outline: none;\n    overflow-y: auto;\n    padding: 12px 15px;\n    tab-size: 4;\n    -moz-tab-size: 4;\n    text-align: left;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n  .ql-editor > * {\n    cursor: text;\n  }\n  .ql-editor p,\n  .ql-editor ol,\n  .ql-editor ul,\n  .ql-editor pre,\n  .ql-editor blockquote,\n  .ql-editor h1,\n  .ql-editor h2,\n  .ql-editor h3,\n  .ql-editor h4,\n  .ql-editor h5,\n  .ql-editor h6 {\n    margin: 0;\n    padding: 0;\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol,\n  .ql-editor ul {\n    padding-left: 1.5em;\n  }\n  .ql-editor ol > li,\n  .ql-editor ul > li {\n    list-style-type: none;\n  }\n  .ql-editor ul > li::before {\n    content: '\\2022';\n  }\n  .ql-editor ul[data-checked='true'],\n  .ql-editor ul[data-checked='false'] {\n    pointer-events: none;\n  }\n  .ql-editor ul[data-checked='true'] > li *,\n  .ql-editor ul[data-checked='false'] > li * {\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked='true'] > li::before,\n  .ql-editor ul[data-checked='false'] > li::before {\n    color: #777;\n    cursor: pointer;\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked='true'] > li::before {\n    content: '\\2611';\n  }\n  .ql-editor ul[data-checked='false'] > li::before {\n    content: '\\2610';\n  }\n  .ql-editor li::before {\n    display: inline-block;\n    white-space: nowrap;\n    width: 1.2em;\n  }\n  .ql-editor li:not(.ql-direction-rtl)::before {\n    margin-left: -1.5em;\n    margin-right: 0.3em;\n    text-align: right;\n  }\n  .ql-editor li.ql-direction-rtl::before {\n    margin-left: 0.3em;\n    margin-right: -1.5em;\n  }\n  .ql-editor ol li:not(.ql-direction-rtl),\n  .ql-editor ul li:not(.ql-direction-rtl) {\n    padding-left: 1.5em;\n  }\n  .ql-editor ol li.ql-direction-rtl,\n  .ql-editor ul li.ql-direction-rtl {\n    padding-right: 1.5em;\n  }\n  .ql-editor ol li {\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    counter-increment: list-0;\n  }\n  .ql-editor ol li:before {\n    content: counter(list-0, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-1 {\n    counter-increment: list-1;\n  }\n  .ql-editor ol li.ql-indent-1:before {\n    content: counter(list-1, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-1 {\n    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-2 {\n    counter-increment: list-2;\n  }\n  .ql-editor ol li.ql-indent-2:before {\n    content: counter(list-2, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-2 {\n    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-3 {\n    counter-increment: list-3;\n  }\n  .ql-editor ol li.ql-indent-3:before {\n    content: counter(list-3, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-3 {\n    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-4 {\n    counter-increment: list-4;\n  }\n  .ql-editor ol li.ql-indent-4:before {\n    content: counter(list-4, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-4 {\n    counter-reset: list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-5 {\n    counter-increment: list-5;\n  }\n  .ql-editor ol li.ql-indent-5:before {\n    content: counter(list-5, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-5 {\n    counter-reset: list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-6 {\n    counter-increment: list-6;\n  }\n  .ql-editor ol li.ql-indent-6:before {\n    content: counter(list-6, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-6 {\n    counter-reset: list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-7 {\n    counter-increment: list-7;\n  }\n  .ql-editor ol li.ql-indent-7:before {\n    content: counter(list-7, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-7 {\n    counter-reset: list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-8 {\n    counter-increment: list-8;\n  }\n  .ql-editor ol li.ql-indent-8:before {\n    content: counter(list-8, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-8 {\n    counter-reset: list-9;\n  }\n  .ql-editor ol li.ql-indent-9 {\n    counter-increment: list-9;\n  }\n  .ql-editor ol li.ql-indent-9:before {\n    content: counter(list-9, decimal) '. ';\n  }\n  .ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 3em;\n  }\n  .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 4.5em;\n  }\n  .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 3em;\n  }\n  .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 4.5em;\n  }\n  .ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 6em;\n  }\n  .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 7.5em;\n  }\n  .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 6em;\n  }\n  .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 7.5em;\n  }\n  .ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 9em;\n  }\n  .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 10.5em;\n  }\n  .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 9em;\n  }\n  .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 10.5em;\n  }\n  .ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 12em;\n  }\n  .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 13.5em;\n  }\n  .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 12em;\n  }\n  .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 13.5em;\n  }\n  .ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 15em;\n  }\n  .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 16.5em;\n  }\n  .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 15em;\n  }\n  .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 16.5em;\n  }\n  .ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 18em;\n  }\n  .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 19.5em;\n  }\n  .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 18em;\n  }\n  .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 19.5em;\n  }\n  .ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 21em;\n  }\n  .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 22.5em;\n  }\n  .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 21em;\n  }\n  .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 22.5em;\n  }\n  .ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 24em;\n  }\n  .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 25.5em;\n  }\n  .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 24em;\n  }\n  .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 25.5em;\n  }\n  .ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 27em;\n  }\n  .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 28.5em;\n  }\n  .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 27em;\n  }\n  .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 28.5em;\n  }\n  .ql-editor .ql-video {\n    display: block;\n    max-width: 100%;\n  }\n  .ql-editor .ql-video.ql-align-center {\n    margin: 0 auto;\n  }\n  .ql-editor .ql-video.ql-align-right {\n    margin: 0 0 0 auto;\n  }\n  .ql-editor .ql-bg-black {\n    background-color: #000;\n  }\n  .ql-editor .ql-bg-red {\n    background-color: #e60000;\n  }\n  .ql-editor .ql-bg-orange {\n    background-color: #f90;\n  }\n  .ql-editor .ql-bg-yellow {\n    background-color: #ff0;\n  }\n  .ql-editor .ql-bg-green {\n    background-color: #008a00;\n  }\n  .ql-editor .ql-bg-blue {\n    background-color: #06c;\n  }\n  .ql-editor .ql-bg-purple {\n    background-color: #93f;\n  }\n  .ql-editor .ql-color-white {\n    color: #fff;\n  }\n  .ql-editor .ql-color-red {\n    color: #e60000;\n  }\n  .ql-editor .ql-color-orange {\n    color: #f90;\n  }\n  .ql-editor .ql-color-yellow {\n    color: #ff0;\n  }\n  .ql-editor .ql-color-green {\n    color: #008a00;\n  }\n  .ql-editor .ql-color-blue {\n    color: #06c;\n  }\n  .ql-editor .ql-color-purple {\n    color: #93f;\n  }\n  .ql-editor .ql-font-serif {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-editor .ql-font-monospace {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-editor .ql-size-small {\n    font-size: 0.75em;\n  }\n  .ql-editor .ql-size-large {\n    font-size: 1.5em;\n  }\n  .ql-editor .ql-size-huge {\n    font-size: 2.5em;\n  }\n  .ql-editor .ql-direction-rtl {\n    direction: rtl;\n    text-align: inherit;\n  }\n  .ql-editor .ql-align-center {\n    text-align: center;\n  }\n  .ql-editor .ql-align-justify {\n    text-align: justify;\n  }\n  .ql-editor .ql-align-right {\n    text-align: right;\n  }\n  .ql-editor.ql-blank::before {\n    color: rgba(0, 0, 0, 0.6);\n    content: attr(data-placeholder);\n    font-style: italic;\n    left: 15px;\n    pointer-events: none;\n    position: absolute;\n    right: 15px;\n  }\n  /*!\n   * Quill Editor v1.3.6\n   * https://quilljs.com/\n   * Copyright (c) 2014, Jason Chen\n   * Copyright (c) 2013, salesforce.com\n   */\n  .ql-container {\n    box-sizing: border-box;\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 13px;\n    height: 100%;\n    margin: 0px;\n    position: relative;\n  }\n  .ql-container.ql-disabled .ql-tooltip {\n    visibility: hidden;\n  }\n  .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n    pointer-events: none;\n  }\n  .ql-clipboard {\n    left: -100000px;\n    height: 1px;\n    overflow-y: hidden;\n    position: absolute;\n    top: 50%;\n  }\n  .ql-clipboard p {\n    margin: 0;\n    padding: 0;\n  }\n  .ql-editor {\n    box-sizing: border-box;\n    line-height: 1.42;\n    height: 100%;\n    outline: none;\n    overflow-y: auto;\n    padding: 12px 15px;\n    tab-size: 4;\n    -moz-tab-size: 4;\n    text-align: left;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n  .ql-editor > * {\n    cursor: text;\n  }\n  .ql-editor p,\n  .ql-editor ol,\n  .ql-editor ul,\n  .ql-editor pre,\n  .ql-editor blockquote,\n  .ql-editor h1,\n  .ql-editor h2,\n  .ql-editor h3,\n  .ql-editor h4,\n  .ql-editor h5,\n  .ql-editor h6 {\n    margin: 0;\n    padding: 0;\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol,\n  .ql-editor ul {\n    padding-left: 1.5em;\n  }\n  .ql-editor ol > li,\n  .ql-editor ul > li {\n    list-style-type: none;\n  }\n  .ql-editor ul > li::before {\n    content: '\\2022';\n  }\n  .ql-editor ul[data-checked='true'],\n  .ql-editor ul[data-checked='false'] {\n    pointer-events: none;\n  }\n  .ql-editor ul[data-checked='true'] > li *,\n  .ql-editor ul[data-checked='false'] > li * {\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked='true'] > li::before,\n  .ql-editor ul[data-checked='false'] > li::before {\n    color: #777;\n    cursor: pointer;\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked='true'] > li::before {\n    content: '\\2611';\n  }\n  .ql-editor ul[data-checked='false'] > li::before {\n    content: '\\2610';\n  }\n  .ql-editor li::before {\n    display: inline-block;\n    white-space: nowrap;\n    width: 1.2em;\n  }\n  .ql-editor li:not(.ql-direction-rtl)::before {\n    margin-left: -1.5em;\n    margin-right: 0.3em;\n    text-align: right;\n  }\n  .ql-editor li.ql-direction-rtl::before {\n    margin-left: 0.3em;\n    margin-right: -1.5em;\n  }\n  .ql-editor ol li:not(.ql-direction-rtl),\n  .ql-editor ul li:not(.ql-direction-rtl) {\n    padding-left: 1.5em;\n  }\n  .ql-editor ol li.ql-direction-rtl,\n  .ql-editor ul li.ql-direction-rtl {\n    padding-right: 1.5em;\n  }\n  .ql-editor ol li {\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    counter-increment: list-0;\n  }\n  .ql-editor ol li:before {\n    content: counter(list-0, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-1 {\n    counter-increment: list-1;\n  }\n  .ql-editor ol li.ql-indent-1:before {\n    content: counter(list-1, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-1 {\n    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-2 {\n    counter-increment: list-2;\n  }\n  .ql-editor ol li.ql-indent-2:before {\n    content: counter(list-2, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-2 {\n    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-3 {\n    counter-increment: list-3;\n  }\n  .ql-editor ol li.ql-indent-3:before {\n    content: counter(list-3, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-3 {\n    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-4 {\n    counter-increment: list-4;\n  }\n  .ql-editor ol li.ql-indent-4:before {\n    content: counter(list-4, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-4 {\n    counter-reset: list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-5 {\n    counter-increment: list-5;\n  }\n  .ql-editor ol li.ql-indent-5:before {\n    content: counter(list-5, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-5 {\n    counter-reset: list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-6 {\n    counter-increment: list-6;\n  }\n  .ql-editor ol li.ql-indent-6:before {\n    content: counter(list-6, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-6 {\n    counter-reset: list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-7 {\n    counter-increment: list-7;\n  }\n  .ql-editor ol li.ql-indent-7:before {\n    content: counter(list-7, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-7 {\n    counter-reset: list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-8 {\n    counter-increment: list-8;\n  }\n  .ql-editor ol li.ql-indent-8:before {\n    content: counter(list-8, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-8 {\n    counter-reset: list-9;\n  }\n  .ql-editor ol li.ql-indent-9 {\n    counter-increment: list-9;\n  }\n  .ql-editor ol li.ql-indent-9:before {\n    content: counter(list-9, decimal) '. ';\n  }\n  .ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 3em;\n  }\n  .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 4.5em;\n  }\n  .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 3em;\n  }\n  .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 4.5em;\n  }\n  .ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 6em;\n  }\n  .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 7.5em;\n  }\n  .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 6em;\n  }\n  .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 7.5em;\n  }\n  .ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 9em;\n  }\n  .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 10.5em;\n  }\n  .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 9em;\n  }\n  .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 10.5em;\n  }\n  .ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 12em;\n  }\n  .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 13.5em;\n  }\n  .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 12em;\n  }\n  .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 13.5em;\n  }\n  .ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 15em;\n  }\n  .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 16.5em;\n  }\n  .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 15em;\n  }\n  .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 16.5em;\n  }\n  .ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 18em;\n  }\n  .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 19.5em;\n  }\n  .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 18em;\n  }\n  .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 19.5em;\n  }\n  .ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 21em;\n  }\n  .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 22.5em;\n  }\n  .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 21em;\n  }\n  .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 22.5em;\n  }\n  .ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 24em;\n  }\n  .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 25.5em;\n  }\n  .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 24em;\n  }\n  .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 25.5em;\n  }\n  .ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 27em;\n  }\n  .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 28.5em;\n  }\n  .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 27em;\n  }\n  .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 28.5em;\n  }\n  .ql-editor .ql-video {\n    display: block;\n    max-width: 100%;\n  }\n  .ql-editor .ql-video.ql-align-center {\n    margin: 0 auto;\n  }\n  .ql-editor .ql-video.ql-align-right {\n    margin: 0 0 0 auto;\n  }\n  .ql-editor .ql-bg-black {\n    background-color: #000;\n  }\n  .ql-editor .ql-bg-red {\n    background-color: #e60000;\n  }\n  .ql-editor .ql-bg-orange {\n    background-color: #f90;\n  }\n  .ql-editor .ql-bg-yellow {\n    background-color: #ff0;\n  }\n  .ql-editor .ql-bg-green {\n    background-color: #008a00;\n  }\n  .ql-editor .ql-bg-blue {\n    background-color: #06c;\n  }\n  .ql-editor .ql-bg-purple {\n    background-color: #93f;\n  }\n  .ql-editor .ql-color-white {\n    color: #fff;\n  }\n  .ql-editor .ql-color-red {\n    color: #e60000;\n  }\n  .ql-editor .ql-color-orange {\n    color: #f90;\n  }\n  .ql-editor .ql-color-yellow {\n    color: #ff0;\n  }\n  .ql-editor .ql-color-green {\n    color: #008a00;\n  }\n  .ql-editor .ql-color-blue {\n    color: #06c;\n  }\n  .ql-editor .ql-color-purple {\n    color: #93f;\n  }\n  .ql-editor .ql-font-serif {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-editor .ql-font-monospace {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-editor .ql-size-small {\n    font-size: 0.75em;\n  }\n  .ql-editor .ql-size-large {\n    font-size: 1.5em;\n  }\n  .ql-editor .ql-size-huge {\n    font-size: 2.5em;\n  }\n  .ql-editor .ql-direction-rtl {\n    direction: rtl;\n    text-align: inherit;\n  }\n  .ql-editor .ql-align-center {\n    text-align: center;\n  }\n  .ql-editor .ql-align-justify {\n    text-align: justify;\n  }\n  .ql-editor .ql-align-right {\n    text-align: right;\n  }\n  .ql-editor.ql-blank::before {\n    color: rgba(0, 0, 0, 0.6);\n    content: attr(data-placeholder);\n    font-style: italic;\n    left: 15px;\n    pointer-events: none;\n    position: absolute;\n    right: 15px;\n  }\n  .ql-bubble.ql-toolbar:after,\n  .ql-bubble .ql-toolbar:after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n  .ql-bubble.ql-toolbar button,\n  .ql-bubble .ql-toolbar button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: inline-block;\n    float: left;\n    height: 24px;\n    padding: 3px 5px;\n    width: 28px;\n  }\n  .ql-bubble.ql-toolbar button svg,\n  .ql-bubble .ql-toolbar button svg {\n    float: left;\n    height: 100%;\n  }\n  .ql-bubble.ql-toolbar button:active:hover,\n  .ql-bubble .ql-toolbar button:active:hover {\n    outline: none;\n  }\n  .ql-bubble.ql-toolbar input.ql-image[type='file'],\n  .ql-bubble .ql-toolbar input.ql-image[type='file'] {\n    display: none;\n  }\n  .ql-bubble.ql-toolbar button:hover,\n  .ql-bubble .ql-toolbar button:hover,\n  .ql-bubble.ql-toolbar button:focus,\n  .ql-bubble .ql-toolbar button:focus,\n  .ql-bubble.ql-toolbar button.ql-active,\n  .ql-bubble .ql-toolbar button.ql-active,\n  .ql-bubble.ql-toolbar .ql-picker-label:hover,\n  .ql-bubble .ql-toolbar .ql-picker-label:hover,\n  .ql-bubble.ql-toolbar .ql-picker-label.ql-active,\n  .ql-bubble .ql-toolbar .ql-picker-label.ql-active,\n  .ql-bubble.ql-toolbar .ql-picker-item:hover,\n  .ql-bubble .ql-toolbar .ql-picker-item:hover,\n  .ql-bubble.ql-toolbar .ql-picker-item.ql-selected,\n  .ql-bubble .ql-toolbar .ql-picker-item.ql-selected {\n    color: #fff;\n  }\n  .ql-bubble.ql-toolbar button:hover .ql-fill,\n  .ql-bubble .ql-toolbar button:hover .ql-fill,\n  .ql-bubble.ql-toolbar button:focus .ql-fill,\n  .ql-bubble .ql-toolbar button:focus .ql-fill,\n  .ql-bubble.ql-toolbar button.ql-active .ql-fill,\n  .ql-bubble .ql-toolbar button.ql-active .ql-fill,\n  .ql-bubble.ql-toolbar .ql-picker-label:hover .ql-fill,\n  .ql-bubble .ql-toolbar .ql-picker-label:hover .ql-fill,\n  .ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n  .ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n  .ql-bubble.ql-toolbar .ql-picker-item:hover .ql-fill,\n  .ql-bubble .ql-toolbar .ql-picker-item:hover .ql-fill,\n  .ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n  .ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n  .ql-bubble.ql-toolbar button:hover .ql-stroke.ql-fill,\n  .ql-bubble .ql-toolbar button:hover .ql-stroke.ql-fill,\n  .ql-bubble.ql-toolbar button:focus .ql-stroke.ql-fill,\n  .ql-bubble .ql-toolbar button:focus .ql-stroke.ql-fill,\n  .ql-bubble.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n  .ql-bubble .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n  .ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n  .ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n  .ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n  .ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n  .ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n  .ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n  .ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n  .ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n    fill: #fff;\n  }\n  .ql-bubble.ql-toolbar button:hover .ql-stroke,\n  .ql-bubble .ql-toolbar button:hover .ql-stroke,\n  .ql-bubble.ql-toolbar button:focus .ql-stroke,\n  .ql-bubble .ql-toolbar button:focus .ql-stroke,\n  .ql-bubble.ql-toolbar button.ql-active .ql-stroke,\n  .ql-bubble .ql-toolbar button.ql-active .ql-stroke,\n  .ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke,\n  .ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke,\n  .ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n  .ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n  .ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke,\n  .ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke,\n  .ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n  .ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n  .ql-bubble.ql-toolbar button:hover .ql-stroke-miter,\n  .ql-bubble .ql-toolbar button:hover .ql-stroke-miter,\n  .ql-bubble.ql-toolbar button:focus .ql-stroke-miter,\n  .ql-bubble .ql-toolbar button:focus .ql-stroke-miter,\n  .ql-bubble.ql-toolbar button.ql-active .ql-stroke-miter,\n  .ql-bubble .ql-toolbar button.ql-active .ql-stroke-miter,\n  .ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n  .ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n  .ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n  .ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n  .ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n  .ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n  .ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n  .ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n    stroke: #fff;\n  }\n  @media (pointer: coarse) {\n    .ql-bubble.ql-toolbar button:hover:not(.ql-active),\n    .ql-bubble .ql-toolbar button:hover:not(.ql-active) {\n      color: #ccc;\n    }\n    .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n    .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n      fill: #ccc;\n    }\n    .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n    .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n      stroke: #ccc;\n    }\n  }\n  .ql-bubble {\n    box-sizing: border-box;\n  }\n  .ql-bubble * {\n    box-sizing: border-box;\n  }\n  .ql-bubble .ql-hidden {\n    display: none;\n  }\n  .ql-bubble .ql-out-bottom,\n  .ql-bubble .ql-out-top {\n    visibility: hidden;\n  }\n  .ql-bubble .ql-tooltip {\n    position: absolute;\n    transform: translateY(10px);\n  }\n  .ql-bubble .ql-tooltip a {\n    cursor: pointer;\n    text-decoration: none;\n  }\n  .ql-bubble .ql-tooltip.ql-flip {\n    transform: translateY(-10px);\n  }\n  .ql-bubble .ql-formats {\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .ql-bubble .ql-formats:after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n  .ql-bubble .ql-stroke {\n    fill: none;\n    stroke: #ccc;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 2;\n  }\n  .ql-bubble .ql-stroke-miter {\n    fill: none;\n    stroke: #ccc;\n    stroke-miterlimit: 10;\n    stroke-width: 2;\n  }\n  .ql-bubble .ql-fill,\n  .ql-bubble .ql-stroke.ql-fill {\n    fill: #ccc;\n  }\n  .ql-bubble .ql-empty {\n    fill: none;\n  }\n  .ql-bubble .ql-even {\n    fill-rule: evenodd;\n  }\n  .ql-bubble .ql-thin,\n  .ql-bubble .ql-stroke.ql-thin {\n    stroke-width: 1;\n  }\n  .ql-bubble .ql-transparent {\n    opacity: 0.4;\n  }\n  .ql-bubble .ql-direction svg:last-child {\n    display: none;\n  }\n  .ql-bubble .ql-direction.ql-active svg:last-child {\n    display: inline;\n  }\n  .ql-bubble .ql-direction.ql-active svg:first-child {\n    display: none;\n  }\n  .ql-bubble .ql-editor h1 {\n    font-size: 2em;\n  }\n  .ql-bubble .ql-editor h2 {\n    font-size: 1.5em;\n  }\n  .ql-bubble .ql-editor h3 {\n    font-size: 1.17em;\n  }\n  .ql-bubble .ql-editor h4 {\n    font-size: 1em;\n  }\n  .ql-bubble .ql-editor h5 {\n    font-size: 0.83em;\n  }\n  .ql-bubble .ql-editor h6 {\n    font-size: 0.67em;\n  }\n  .ql-bubble .ql-editor a {\n    text-decoration: underline;\n  }\n  .ql-bubble .ql-editor blockquote {\n    border-left: 4px solid #ccc;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding-left: 16px;\n  }\n  .ql-bubble .ql-editor code,\n  .ql-bubble .ql-editor pre {\n    background-color: #f0f0f0;\n    border-radius: 3px;\n  }\n  .ql-bubble .ql-editor pre {\n    white-space: pre-wrap;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding: 5px 10px;\n  }\n  .ql-bubble .ql-editor code {\n    font-size: 85%;\n    padding: 2px 4px;\n  }\n  .ql-bubble .ql-editor pre.ql-syntax {\n    background-color: #23241f;\n    color: #f8f8f2;\n    overflow: visible;\n  }\n  .ql-bubble .ql-editor img {\n    max-width: 100%;\n  }\n  .ql-bubble .ql-picker {\n    color: #ccc;\n    display: inline-block;\n    float: left;\n    font-size: 14px;\n    font-weight: 500;\n    height: 24px;\n    position: relative;\n    vertical-align: middle;\n  }\n  .ql-bubble .ql-picker-label {\n    cursor: pointer;\n    display: inline-block;\n    height: 100%;\n    padding-left: 8px;\n    padding-right: 2px;\n    position: relative;\n    width: 100%;\n  }\n  .ql-bubble .ql-picker-label::before {\n    display: inline-block;\n    line-height: 22px;\n  }\n  .ql-bubble .ql-picker-options {\n    background-color: #444;\n    display: none;\n    min-width: 100%;\n    padding: 4px 8px;\n    position: absolute;\n    white-space: nowrap;\n  }\n  .ql-bubble .ql-picker-options .ql-picker-item {\n    cursor: pointer;\n    display: block;\n    padding-bottom: 5px;\n    padding-top: 5px;\n  }\n  .ql-bubble .ql-picker.ql-expanded .ql-picker-label {\n    color: #777;\n    z-index: 2;\n  }\n  .ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n    fill: #777;\n  }\n  .ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n    stroke: #777;\n  }\n  .ql-bubble .ql-picker.ql-expanded .ql-picker-options {\n    display: block;\n    margin-top: -1px;\n    top: 100%;\n    z-index: 1;\n  }\n  .ql-bubble .ql-color-picker,\n  .ql-bubble .ql-icon-picker {\n    width: 28px;\n  }\n  .ql-bubble .ql-color-picker .ql-picker-label,\n  .ql-bubble .ql-icon-picker .ql-picker-label {\n    padding: 2px 4px;\n  }\n  .ql-bubble .ql-color-picker .ql-picker-label svg,\n  .ql-bubble .ql-icon-picker .ql-picker-label svg {\n    right: 4px;\n  }\n  .ql-bubble .ql-icon-picker .ql-picker-options {\n    padding: 4px 0px;\n  }\n  .ql-bubble .ql-icon-picker .ql-picker-item {\n    height: 24px;\n    width: 24px;\n    padding: 2px 4px;\n  }\n  .ql-bubble .ql-color-picker .ql-picker-options {\n    padding: 3px 5px;\n    width: 152px;\n  }\n  .ql-bubble .ql-color-picker .ql-picker-item {\n    border: 1px solid transparent;\n    float: left;\n    height: 16px;\n    margin: 2px;\n    padding: 0px;\n    width: 16px;\n  }\n  .ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n    position: absolute;\n    margin-top: -9px;\n    right: 0;\n    top: 50%;\n    width: 18px;\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-bubble .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-bubble .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n  .ql-bubble .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n  .ql-bubble .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n    content: attr(data-label);\n  }\n  .ql-bubble .ql-picker.ql-header {\n    width: 98px;\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-label::before,\n  .ql-bubble .ql-picker.ql-header .ql-picker-item::before {\n    content: 'Normal';\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='1']::before,\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n    content: 'Heading 1';\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='2']::before,\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n    content: 'Heading 2';\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='3']::before,\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n    content: 'Heading 3';\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='4']::before,\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='4']::before {\n    content: 'Heading 4';\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='5']::before,\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='5']::before {\n    content: 'Heading 5';\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='6']::before,\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='6']::before {\n    content: 'Heading 6';\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n    font-size: 2em;\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n    font-size: 1.5em;\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n    font-size: 1.17em;\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='4']::before {\n    font-size: 1em;\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='5']::before {\n    font-size: 0.83em;\n  }\n  .ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='6']::before {\n    font-size: 0.67em;\n  }\n  .ql-bubble .ql-picker.ql-font {\n    width: 108px;\n  }\n  .ql-bubble .ql-picker.ql-font .ql-picker-label::before,\n  .ql-bubble .ql-picker.ql-font .ql-picker-item::before {\n    content: 'Sans Serif';\n  }\n  .ql-bubble .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,\n  .ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {\n    content: 'Serif';\n  }\n  .ql-bubble .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,\n  .ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {\n    content: 'Monospace';\n  }\n  .ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-bubble .ql-picker.ql-size {\n    width: 98px;\n  }\n  .ql-bubble .ql-picker.ql-size .ql-picker-label::before,\n  .ql-bubble .ql-picker.ql-size .ql-picker-item::before {\n    content: 'Normal';\n  }\n  .ql-bubble .ql-picker.ql-size .ql-picker-label[data-value='small']::before,\n  .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n    content: 'Small';\n  }\n  .ql-bubble .ql-picker.ql-size .ql-picker-label[data-value='large']::before,\n  .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n    content: 'Large';\n  }\n  .ql-bubble .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,\n  .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n    content: 'Huge';\n  }\n  .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n    font-size: 10px;\n  }\n  .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n    font-size: 18px;\n  }\n  .ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n    font-size: 32px;\n  }\n  .ql-bubble .ql-color-picker.ql-background .ql-picker-item {\n    background-color: #fff;\n  }\n  .ql-bubble .ql-color-picker.ql-color .ql-picker-item {\n    background-color: #000;\n  }\n  .ql-bubble .ql-toolbar .ql-formats {\n    margin: 8px 12px 8px 0px;\n  }\n  .ql-bubble .ql-toolbar .ql-formats:first-child {\n    margin-left: 12px;\n  }\n  .ql-bubble .ql-color-picker svg {\n    margin: 1px;\n  }\n  .ql-bubble .ql-color-picker .ql-picker-item.ql-selected,\n  .ql-bubble .ql-color-picker .ql-picker-item:hover {\n    border-color: #fff;\n  }\n  .ql-bubble .ql-tooltip {\n    background-color: #444;\n    border-radius: 25px;\n    color: #fff;\n  }\n  .ql-bubble .ql-tooltip-arrow {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    content: ' ';\n    display: block;\n    left: 50%;\n    margin-left: -6px;\n    position: absolute;\n  }\n  .ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow {\n    border-bottom: 6px solid #444;\n    top: -6px;\n  }\n  .ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow {\n    border-top: 6px solid #444;\n    bottom: -6px;\n  }\n  .ql-bubble .ql-tooltip.ql-editing .ql-tooltip-editor {\n    display: block;\n  }\n  .ql-bubble .ql-tooltip.ql-editing .ql-formats {\n    visibility: hidden;\n  }\n  .ql-bubble .ql-tooltip-editor {\n    display: none;\n  }\n  .ql-bubble .ql-tooltip-editor input[type='text'] {\n    background: transparent;\n    border: none;\n    color: #fff;\n    font-size: 13px;\n    height: 100%;\n    outline: none;\n    padding: 10px 20px;\n    position: absolute;\n    width: 100%;\n  }\n  .ql-bubble .ql-tooltip-editor a {\n    top: 10px;\n    position: absolute;\n    right: 20px;\n  }\n  .ql-bubble .ql-tooltip-editor a:before {\n    color: #ccc;\n    content: '\\D7';\n    font-size: 16px;\n    font-weight: bold;\n  }\n  .ql-container.ql-bubble:not(.ql-disabled) a {\n    position: relative;\n    white-space: nowrap;\n  }\n  .ql-container.ql-bubble:not(.ql-disabled) a::before {\n    background-color: #444;\n    border-radius: 15px;\n    top: -5px;\n    font-size: 12px;\n    color: #fff;\n    content: attr(href);\n    font-weight: normal;\n    overflow: hidden;\n    padding: 5px 15px;\n    text-decoration: none;\n    z-index: 1;\n  }\n  .ql-container.ql-bubble:not(.ql-disabled) a::after {\n    border-top: 6px solid #444;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    top: 0;\n    content: ' ';\n    height: 0;\n    width: 0;\n  }\n  .ql-container.ql-bubble:not(.ql-disabled) a::before,\n  .ql-container.ql-bubble:not(.ql-disabled) a::after {\n    left: 0;\n    margin-left: 50%;\n    position: absolute;\n    transform: translate(-50%, -100%);\n    transition: visibility 0s ease 200ms;\n    visibility: hidden;\n  }\n  .ql-container.ql-bubble:not(.ql-disabled) a:hover::before,\n  .ql-container.ql-bubble:not(.ql-disabled) a:hover::after {\n    visibility: visible;\n  }\n  /*!\n   * Quill Editor v1.3.6\n   * https://quilljs.com/\n   * Copyright (c) 2014, Jason Chen\n   * Copyright (c) 2013, salesforce.com\n   */\n  .ql-container {\n    box-sizing: border-box;\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 13px;\n    height: 100%;\n    margin: 0px;\n    position: relative;\n  }\n  .ql-container.ql-disabled .ql-tooltip {\n    visibility: hidden;\n  }\n  .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n    pointer-events: none;\n  }\n  .ql-clipboard {\n    left: -100000px;\n    height: 1px;\n    overflow-y: hidden;\n    position: absolute;\n    top: 50%;\n  }\n  .ql-clipboard p {\n    margin: 0;\n    padding: 0;\n  }\n  .ql-editor {\n    box-sizing: border-box;\n    line-height: 1.42;\n    height: 100%;\n    outline: none;\n    overflow-y: auto;\n    padding: 12px 15px;\n    tab-size: 4;\n    -moz-tab-size: 4;\n    text-align: left;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n  .ql-editor > * {\n    cursor: text;\n  }\n  .ql-editor p,\n  .ql-editor ol,\n  .ql-editor ul,\n  .ql-editor pre,\n  .ql-editor blockquote,\n  .ql-editor h1,\n  .ql-editor h2,\n  .ql-editor h3,\n  .ql-editor h4,\n  .ql-editor h5,\n  .ql-editor h6 {\n    margin: 0;\n    padding: 0;\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol,\n  .ql-editor ul {\n    padding-left: 1.5em;\n  }\n  .ql-editor ol > li,\n  .ql-editor ul > li {\n    list-style-type: none;\n  }\n  .ql-editor ul > li::before {\n    content: '\\2022';\n  }\n  .ql-editor ul[data-checked='true'],\n  .ql-editor ul[data-checked='false'] {\n    pointer-events: none;\n  }\n  .ql-editor ul[data-checked='true'] > li *,\n  .ql-editor ul[data-checked='false'] > li * {\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked='true'] > li::before,\n  .ql-editor ul[data-checked='false'] > li::before {\n    color: #777;\n    cursor: pointer;\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked='true'] > li::before {\n    content: '\\2611';\n  }\n  .ql-editor ul[data-checked='false'] > li::before {\n    content: '\\2610';\n  }\n  .ql-editor li::before {\n    display: inline-block;\n    white-space: nowrap;\n    width: 1.2em;\n  }\n  .ql-editor li:not(.ql-direction-rtl)::before {\n    margin-left: -1.5em;\n    margin-right: 0.3em;\n    text-align: right;\n  }\n  .ql-editor li.ql-direction-rtl::before {\n    margin-left: 0.3em;\n    margin-right: -1.5em;\n  }\n  .ql-editor ol li:not(.ql-direction-rtl),\n  .ql-editor ul li:not(.ql-direction-rtl) {\n    padding-left: 1.5em;\n  }\n  .ql-editor ol li.ql-direction-rtl,\n  .ql-editor ul li.ql-direction-rtl {\n    padding-right: 1.5em;\n  }\n  .ql-editor ol li {\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    counter-increment: list-0;\n  }\n  .ql-editor ol li:before {\n    content: counter(list-0, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-1 {\n    counter-increment: list-1;\n  }\n  .ql-editor ol li.ql-indent-1:before {\n    content: counter(list-1, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-1 {\n    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-2 {\n    counter-increment: list-2;\n  }\n  .ql-editor ol li.ql-indent-2:before {\n    content: counter(list-2, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-2 {\n    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-3 {\n    counter-increment: list-3;\n  }\n  .ql-editor ol li.ql-indent-3:before {\n    content: counter(list-3, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-3 {\n    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-4 {\n    counter-increment: list-4;\n  }\n  .ql-editor ol li.ql-indent-4:before {\n    content: counter(list-4, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-4 {\n    counter-reset: list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-5 {\n    counter-increment: list-5;\n  }\n  .ql-editor ol li.ql-indent-5:before {\n    content: counter(list-5, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-5 {\n    counter-reset: list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-6 {\n    counter-increment: list-6;\n  }\n  .ql-editor ol li.ql-indent-6:before {\n    content: counter(list-6, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-6 {\n    counter-reset: list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-7 {\n    counter-increment: list-7;\n  }\n  .ql-editor ol li.ql-indent-7:before {\n    content: counter(list-7, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-7 {\n    counter-reset: list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-8 {\n    counter-increment: list-8;\n  }\n  .ql-editor ol li.ql-indent-8:before {\n    content: counter(list-8, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-8 {\n    counter-reset: list-9;\n  }\n  .ql-editor ol li.ql-indent-9 {\n    counter-increment: list-9;\n  }\n  .ql-editor ol li.ql-indent-9:before {\n    content: counter(list-9, decimal) '. ';\n  }\n  .ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 3em;\n  }\n  .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 4.5em;\n  }\n  .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 3em;\n  }\n  .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 4.5em;\n  }\n  .ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 6em;\n  }\n  .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 7.5em;\n  }\n  .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 6em;\n  }\n  .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 7.5em;\n  }\n  .ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 9em;\n  }\n  .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 10.5em;\n  }\n  .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 9em;\n  }\n  .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 10.5em;\n  }\n  .ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 12em;\n  }\n  .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 13.5em;\n  }\n  .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 12em;\n  }\n  .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 13.5em;\n  }\n  .ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 15em;\n  }\n  .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 16.5em;\n  }\n  .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 15em;\n  }\n  .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 16.5em;\n  }\n  .ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 18em;\n  }\n  .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 19.5em;\n  }\n  .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 18em;\n  }\n  .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 19.5em;\n  }\n  .ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 21em;\n  }\n  .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 22.5em;\n  }\n  .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 21em;\n  }\n  .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 22.5em;\n  }\n  .ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 24em;\n  }\n  .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 25.5em;\n  }\n  .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 24em;\n  }\n  .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 25.5em;\n  }\n  .ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 27em;\n  }\n  .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 28.5em;\n  }\n  .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 27em;\n  }\n  .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 28.5em;\n  }\n  .ql-editor .ql-video {\n    display: block;\n    max-width: 100%;\n  }\n  .ql-editor .ql-video.ql-align-center {\n    margin: 0 auto;\n  }\n  .ql-editor .ql-video.ql-align-right {\n    margin: 0 0 0 auto;\n  }\n  .ql-editor .ql-bg-black {\n    background-color: #000;\n  }\n  .ql-editor .ql-bg-red {\n    background-color: #e60000;\n  }\n  .ql-editor .ql-bg-orange {\n    background-color: #f90;\n  }\n  .ql-editor .ql-bg-yellow {\n    background-color: #ff0;\n  }\n  .ql-editor .ql-bg-green {\n    background-color: #008a00;\n  }\n  .ql-editor .ql-bg-blue {\n    background-color: #06c;\n  }\n  .ql-editor .ql-bg-purple {\n    background-color: #93f;\n  }\n  .ql-editor .ql-color-white {\n    color: #fff;\n  }\n  .ql-editor .ql-color-red {\n    color: #e60000;\n  }\n  .ql-editor .ql-color-orange {\n    color: #f90;\n  }\n  .ql-editor .ql-color-yellow {\n    color: #ff0;\n  }\n  .ql-editor .ql-color-green {\n    color: #008a00;\n  }\n  .ql-editor .ql-color-blue {\n    color: #06c;\n  }\n  .ql-editor .ql-color-purple {\n    color: #93f;\n  }\n  .ql-editor .ql-font-serif {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-editor .ql-font-monospace {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-editor .ql-size-small {\n    font-size: 0.75em;\n  }\n  .ql-editor .ql-size-large {\n    font-size: 1.5em;\n  }\n  .ql-editor .ql-size-huge {\n    font-size: 2.5em;\n  }\n  .ql-editor .ql-direction-rtl {\n    direction: rtl;\n    text-align: inherit;\n  }\n  .ql-editor .ql-align-center {\n    text-align: center;\n  }\n  .ql-editor .ql-align-justify {\n    text-align: justify;\n  }\n  .ql-editor .ql-align-right {\n    text-align: right;\n  }\n  .ql-editor.ql-blank::before {\n    color: rgba(0, 0, 0, 0.6);\n    content: attr(data-placeholder);\n    font-style: italic;\n    left: 15px;\n    pointer-events: none;\n    position: absolute;\n    right: 15px;\n  }\n  .ql-snow.ql-toolbar:after,\n  .ql-snow .ql-toolbar:after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n  .ql-snow.ql-toolbar button,\n  .ql-snow .ql-toolbar button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: inline-block;\n    float: left;\n    height: 24px;\n    padding: 3px 5px;\n    width: 28px;\n  }\n  .ql-snow.ql-toolbar button svg,\n  .ql-snow .ql-toolbar button svg {\n    float: left;\n    height: 100%;\n  }\n  .ql-snow.ql-toolbar button:active:hover,\n  .ql-snow .ql-toolbar button:active:hover {\n    outline: none;\n  }\n  .ql-snow.ql-toolbar input.ql-image[type='file'],\n  .ql-snow .ql-toolbar input.ql-image[type='file'] {\n    display: none;\n  }\n  .ql-snow.ql-toolbar button:hover,\n  .ql-snow .ql-toolbar button:hover,\n  .ql-snow.ql-toolbar button:focus,\n  .ql-snow .ql-toolbar button:focus,\n  .ql-snow.ql-toolbar button.ql-active,\n  .ql-snow .ql-toolbar button.ql-active,\n  .ql-snow.ql-toolbar .ql-picker-label:hover,\n  .ql-snow .ql-toolbar .ql-picker-label:hover,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active,\n  .ql-snow.ql-toolbar .ql-picker-item:hover,\n  .ql-snow .ql-toolbar .ql-picker-item:hover,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n    color: #06c;\n  }\n  .ql-snow.ql-toolbar button:hover .ql-fill,\n  .ql-snow .ql-toolbar button:hover .ql-fill,\n  .ql-snow.ql-toolbar button:focus .ql-fill,\n  .ql-snow .ql-toolbar button:focus .ql-fill,\n  .ql-snow.ql-toolbar button.ql-active .ql-fill,\n  .ql-snow .ql-toolbar button.ql-active .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n  .ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n    fill: #06c;\n  }\n  .ql-snow.ql-toolbar button:hover .ql-stroke,\n  .ql-snow .ql-toolbar button:hover .ql-stroke,\n  .ql-snow.ql-toolbar button:focus .ql-stroke,\n  .ql-snow .ql-toolbar button:focus .ql-stroke,\n  .ql-snow.ql-toolbar button.ql-active .ql-stroke,\n  .ql-snow .ql-toolbar button.ql-active .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n  .ql-snow.ql-toolbar button:hover .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:hover .ql-stroke-miter,\n  .ql-snow.ql-toolbar button:focus .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:focus .ql-stroke-miter,\n  .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,\n  .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n    stroke: #06c;\n  }\n  @media (pointer: coarse) {\n    .ql-snow.ql-toolbar button:hover:not(.ql-active),\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n      color: #444;\n    }\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n      fill: #444;\n    }\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n      stroke: #444;\n    }\n  }\n  .ql-snow {\n    box-sizing: border-box;\n  }\n  .ql-snow * {\n    box-sizing: border-box;\n  }\n  .ql-snow .ql-hidden {\n    display: none;\n  }\n  .ql-snow .ql-out-bottom,\n  .ql-snow .ql-out-top {\n    visibility: hidden;\n  }\n  .ql-snow .ql-tooltip {\n    position: absolute;\n    transform: translateY(10px);\n  }\n  .ql-snow .ql-tooltip a {\n    cursor: pointer;\n    text-decoration: none;\n  }\n  .ql-snow .ql-tooltip.ql-flip {\n    transform: translateY(-10px);\n  }\n  .ql-snow .ql-formats {\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .ql-snow .ql-formats:after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n  .ql-snow .ql-stroke {\n    fill: none;\n    stroke: #444;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 2;\n  }\n  .ql-snow .ql-stroke-miter {\n    fill: none;\n    stroke: #444;\n    stroke-miterlimit: 10;\n    stroke-width: 2;\n  }\n  .ql-snow .ql-fill,\n  .ql-snow .ql-stroke.ql-fill {\n    fill: #444;\n  }\n  .ql-snow .ql-empty {\n    fill: none;\n  }\n  .ql-snow .ql-even {\n    fill-rule: evenodd;\n  }\n  .ql-snow .ql-thin,\n  .ql-snow .ql-stroke.ql-thin {\n    stroke-width: 1;\n  }\n  .ql-snow .ql-transparent {\n    opacity: 0.4;\n  }\n  .ql-snow .ql-direction svg:last-child {\n    display: none;\n  }\n  .ql-snow .ql-direction.ql-active svg:last-child {\n    display: inline;\n  }\n  .ql-snow .ql-direction.ql-active svg:first-child {\n    display: none;\n  }\n  .ql-snow .ql-editor h1 {\n    font-size: 2em;\n  }\n  .ql-snow .ql-editor h2 {\n    font-size: 1.5em;\n  }\n  .ql-snow .ql-editor h3 {\n    font-size: 1.17em;\n  }\n  .ql-snow .ql-editor h4 {\n    font-size: 1em;\n  }\n  .ql-snow .ql-editor h5 {\n    font-size: 0.83em;\n  }\n  .ql-snow .ql-editor h6 {\n    font-size: 0.67em;\n  }\n  .ql-snow .ql-editor a {\n    text-decoration: underline;\n  }\n  .ql-snow .ql-editor blockquote {\n    border-left: 4px solid #ccc;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding-left: 16px;\n  }\n  .ql-snow .ql-editor code,\n  .ql-snow .ql-editor pre {\n    background-color: #f0f0f0;\n    border-radius: 3px;\n  }\n  .ql-snow .ql-editor pre {\n    white-space: pre-wrap;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding: 5px 10px;\n  }\n  .ql-snow .ql-editor code {\n    font-size: 85%;\n    padding: 2px 4px;\n  }\n  .ql-snow .ql-editor pre.ql-syntax {\n    background-color: #23241f;\n    color: #f8f8f2;\n    overflow: visible;\n  }\n  .ql-snow .ql-editor img {\n    max-width: 100%;\n  }\n  .ql-snow .ql-picker {\n    color: #444;\n    display: inline-block;\n    float: left;\n    font-size: 14px;\n    font-weight: 500;\n    height: 24px;\n    position: relative;\n    vertical-align: middle;\n  }\n  .ql-snow .ql-picker-label {\n    cursor: pointer;\n    display: inline-block;\n    height: 100%;\n    padding-left: 8px;\n    padding-right: 2px;\n    position: relative;\n    width: 100%;\n  }\n  .ql-snow .ql-picker-label::before {\n    display: inline-block;\n    line-height: 22px;\n  }\n  .ql-snow .ql-picker-options {\n    background-color: #fff;\n    display: none;\n    min-width: 100%;\n    padding: 4px 8px;\n    position: absolute;\n    white-space: nowrap;\n  }\n  .ql-snow .ql-picker-options .ql-picker-item {\n    cursor: pointer;\n    display: block;\n    padding-bottom: 5px;\n    padding-top: 5px;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label {\n    color: #ccc;\n    z-index: 2;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n    fill: #ccc;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n    stroke: #ccc;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    display: block;\n    margin-top: -1px;\n    top: 100%;\n    z-index: 1;\n  }\n  .ql-snow .ql-color-picker,\n  .ql-snow .ql-icon-picker {\n    width: 28px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-label,\n  .ql-snow .ql-icon-picker .ql-picker-label {\n    padding: 2px 4px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-label svg,\n  .ql-snow .ql-icon-picker .ql-picker-label svg {\n    right: 4px;\n  }\n  .ql-snow .ql-icon-picker .ql-picker-options {\n    padding: 4px 0px;\n  }\n  .ql-snow .ql-icon-picker .ql-picker-item {\n    height: 24px;\n    width: 24px;\n    padding: 2px 4px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-options {\n    padding: 3px 5px;\n    width: 152px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-item {\n    border: 1px solid transparent;\n    float: left;\n    height: 16px;\n    margin: 2px;\n    padding: 0px;\n    width: 16px;\n  }\n  .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n    position: absolute;\n    margin-top: -9px;\n    right: 0;\n    top: 50%;\n    width: 18px;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n    content: attr(data-label);\n  }\n  .ql-snow .ql-picker.ql-header {\n    width: 98px;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item::before {\n    content: 'Normal';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n    content: 'Heading 1';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n    content: 'Heading 2';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n    content: 'Heading 3';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {\n    content: 'Heading 4';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {\n    content: 'Heading 5';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {\n    content: 'Heading 6';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n    font-size: 2em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n    font-size: 1.5em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n    font-size: 1.17em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {\n    font-size: 1em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {\n    font-size: 0.83em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {\n    font-size: 0.67em;\n  }\n  .ql-snow .ql-picker.ql-font {\n    width: 108px;\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-label::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item::before {\n    content: 'Sans Serif';\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {\n    content: 'Serif';\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {\n    content: 'Monospace';\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-snow .ql-picker.ql-size {\n    width: 98px;\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item::before {\n    content: 'Normal';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n    content: 'Small';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n    content: 'Large';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n    content: 'Huge';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n    font-size: 10px;\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n    font-size: 18px;\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n    font-size: 32px;\n  }\n  .ql-snow .ql-color-picker.ql-background .ql-picker-item {\n    background-color: #fff;\n  }\n  .ql-snow .ql-color-picker.ql-color .ql-picker-item {\n    background-color: #000;\n  }\n  .ql-toolbar.ql-snow {\n    border: 1px solid #ccc;\n    box-sizing: border-box;\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n    padding: 8px;\n  }\n  .ql-toolbar.ql-snow .ql-formats {\n    margin-right: 15px;\n  }\n  .ql-toolbar.ql-snow .ql-picker-label {\n    border: 1px solid transparent;\n  }\n  .ql-toolbar.ql-snow .ql-picker-options {\n    border: 1px solid transparent;\n    box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;\n  }\n  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n    border-color: #ccc;\n  }\n  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    border-color: #ccc;\n  }\n  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n    border-color: #000;\n  }\n  .ql-toolbar.ql-snow + .ql-container.ql-snow {\n    border-top: 0px;\n  }\n  .ql-snow .ql-tooltip {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0px 0px 5px #ddd;\n    color: #444;\n    padding: 5px 12px;\n    white-space: nowrap;\n  }\n  .ql-snow .ql-tooltip::before {\n    content: 'Visit URL:';\n    line-height: 26px;\n    margin-right: 8px;\n  }\n  .ql-snow .ql-tooltip input[type='text'] {\n    display: none;\n    border: 1px solid #ccc;\n    font-size: 13px;\n    height: 26px;\n    margin: 0px;\n    padding: 3px 5px;\n    width: 170px;\n  }\n  .ql-snow .ql-tooltip a.ql-preview {\n    display: inline-block;\n    max-width: 200px;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top;\n  }\n  .ql-snow .ql-tooltip a.ql-action::after {\n    border-right: 1px solid #ccc;\n    content: 'Edit';\n    margin-left: 16px;\n    padding-right: 8px;\n  }\n  .ql-snow .ql-tooltip a.ql-remove::before {\n    content: 'Remove';\n    margin-left: 8px;\n  }\n  .ql-snow .ql-tooltip a {\n    line-height: 26px;\n  }\n  .ql-snow .ql-tooltip.ql-editing a.ql-preview,\n  .ql-snow .ql-tooltip.ql-editing a.ql-remove {\n    display: none;\n  }\n  .ql-snow .ql-tooltip.ql-editing input[type='text'] {\n    display: inline-block;\n  }\n  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n    border-right: 0px;\n    content: 'Save';\n    padding-right: 0px;\n  }\n  .ql-snow .ql-tooltip[data-mode='link']::before {\n    content: 'Enter link:';\n  }\n  .ql-snow .ql-tooltip[data-mode='formula']::before {\n    content: 'Enter formula:';\n  }\n  .ql-snow .ql-tooltip[data-mode='video']::before {\n    content: 'Enter video:';\n  }\n  .ql-snow a {\n    color: #06c;\n  }\n  .ql-container.ql-snow {\n    border: 1px solid #ccc;\n  }\n\n  .alert-radio-label {\n    white-space: normal !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
